import { defineTranslations, type TranslationRecord } from "@festina-life/core"

import type { en } from "./en"
import { nlConfiguredEnums, nlEnums } from "./enum.nl"

export const nl = defineTranslations<TranslationRecord<typeof en>>()({
  ...nlEnums,
  ...nlConfiguredEnums,
  "InstallmentSpecification.amount": "Bedrag",
  "InstallmentSpecification.dueDate": "Vervaldatum",
  "action.addAnnotation": "Annotaties toevoegen",
  "action.addBalancePosting.field.accountType": "Soort rekening",
  "action.addBalancePosting.field.amount": "Bedrag",
  "action.addBalancePosting.field.balancePostingSpecs": "Balance posteringer specificaties",
  "action.addBalancePosting.field.changeDate": "Wijzigingsdatum",
  "action.addBalancePosting.field.coverKey": "Dekkingskenmerk",
  "action.addBalancePosting.field.fraction": "Fractie",
  "action.addBalancePosting.field.fractionBalancePostingSpecs": "Fractie balance posteringer specificaties",
  "action.addBalancePosting.field.policeKey": "Polis",
  "action.addBalancePosting.field.postingType": "Type boeking",
  "action.addBalancePosting.title": "Saldo toevoegen",
  "action.addFractionBalancePosting.title": "Fractie saldo toevoegen",
  "action.addPayableStop.title": "Betalingsstop toevoegen",
  "action.addPaymentChannel._type": "Rekeningtype",
  "action.addPaymentChannel.accountSelection": "Rekening",
  "action.addPaymentChannel.addAccount": "Rekening toevoegen",
  "action.addPaymentChannel.applyDate": "Toepassingsdatum",
  "action.addPaymentChannel.currencyCode": "Valutacode",
  "action.addPaymentChannel.paymentChannelCriteria": "Betalingskanaalcriteria",
  "action.addPaymentChannel.paymentChannelCriteriaElement": "Betalingskanaalcriterium",
  "action.addPaymentChannel.title": "Betalingskanaal toevoegen",
  "action.amendAnnotation": "Annotaties wijzigen",
  "action.annotation.title": "Annotaties",
  "action.changeAddress.button": "Adres",
  "action.createInvoice.billingMethodType": "Factuur betalingsmethode",
  "action.createInvoice.externalPostingType": "Externe boekingstype",
  "action.createInvoice.internalPaymentDueDate": "Interne betalingsdatum",
  "action.createInvoice.invoiceStatus": "Factuur status",
  "action.createInvoice.invoiceStrategyId": "Factuurstrategie-ID",
  "action.createInvoice.invoiceType": "Factuur type",
  "action.createInvoice.lastOperationDate": "Laatste bewerkingsdatum",
  "action.createInvoice.lastOperationId": "Laatste bewerkings-ID",
  "action.createInvoice.paidAmount": "Betaald bedrag",
  "action.createInvoice.paymentDueDate": "Betalingsdatum",
  "action.createInvoice.suspensionDate": "Opschortingsdatum",
  "action.createInvoice.suspensionReason": "Opschortingsreden",
  "action.createInvoice.title": "Factuur aanmaken",
  "action.createPaymentReceiver.applyDate": "Toepassingsdatum",
  "action.createPaymentReceiver.title": "Betalingsontvanger aanmaken",
  "action.creditPaymentInvoice.paymentDate": "Betaaldatum",
  "action.creditPaymentInvoice.title": "Credit betalingsfactuur",
  "action.deletePayableStop.title": "Betalingsstop verwijderen",
  "action.deletePaymentChannel.input.applyDate": "Toepassingsdatum",
  "action.deletePaymentChannel.title": "Betalingskanaal verwijderen",
  "action.disablePenaltiesInvoice": "Annuleer aanmaningskosten op factuur",
  "action.editPayableStop.title": "Betalingsstop bewerken",
  "action.editPaymentChannel.applyDate": "Toepassingsdatum",
  "action.editPaymentChannel.channelId": "Betalingskanaal",
  "action.editPaymentChannel.title": "Betalingskanaal bewerken",
  "action.invoicePaymentWithdrawal.disabledDueToManualWriteOffAvailable": "Kan een reguliere betaling niet intrekken zolang er een handmatige afschrijvingsbetaling bestaat",
  "action.invoicePaymentWithdrawal.disabledDueToWriteOff": "Kan niet worden ingetrokken vanwege afschrijving",
  "action.invoicePaymentWithdrawal.input.newDueDate": "Nieuwe vervaldatum",
  "action.invoicePaymentWithdrawal.input.nextOperationDate": "Volgende operatiedatum",
  "action.invoicePaymentWithdrawal.input.nextOperationId": "Volgende operatie-ID",
  "action.invoicePaymentWithdrawal.title": "Factuur betaling intrekken",
  "action.pauseInvoice": "Factuur pauzeren",
  "action.payableStop.addText": "Reden toevoegen",
  "action.payableStop.applyDate": "Toepassingsdatum",
  "action.payableStop.payableStopType": "Type",
  "action.payableStop.stopId": "Betalingsstop",
  "action.payableStop.text": "Reden",
  "action.removeAnnotation": "Annotaties verwijderen",
  "action.resumeInvoice": "Factuur hervatten",
  "action.retirement": "Pensionering",
  "action.retirement.input.retirementDate": "Pensioendatum",
  "action.retirement.input.retirementFraction": "Percentage pensionering",
  "action.setDefaultPaymentChannel.applyDate": "Toepassingsdatum",
  "action.setDefaultPaymentChannel.title": "Standaard betalingskanaal instellen",
  "action.testFullTradeCycle.title": "TEST-opdracht - volledige handelscyclus",
  "actionReasonCode.approvePendingCancellationAlreadyPending": "Annuleer goedkeuring al in behandeling",
  "actionReasonCode.insufficientAccess": "Onvoldoende toegang",
  "actions.addManualInvoice": "Factuur toevoegen",
  "actions.createInstallmentPlan": "Afbetalingsplan",
  "actions.setLegalentityStopFlags": "Legalentity: stop",
  "actions.setLifeStopFlags": "Life: stop",
  "actions.setUnitlinkStopFlags": "UnitLink: stop",
  "actions.viewInvoiceElements": "Factuurelementen bekijken",
  "actions.writeOffInvoice.paymentDate": "Betaaldatum",
  "actions.writeOffInvoice.title": "Afschrijving factuur",
  "actions.writeOffInvoice.writeOffCategory": "Categorie afschrijving",
  "activeRecurringMoneyOutVersionDetails.lifeDependent": "Bij leven",
  "activeRecurringMoneyOutVersionDetails.moneyOutEndDate": "Einde uitbetaling",
  "activeRecurringMoneyOutVersionDetails.moneyOutLength": "Duur uitbetaling",
  "activeRecurringMoneyOutVersionDetails.moneyOutStart": "Start uitbetaling",
  "activeRecurringMoneyOutVersionDetails.moneyOutTaxCode": "Belastingcode uitbetaling",
  "activeRecurringMoneyOutVersionDetails.moneyOutType": "Type betaling",
  "activeRecurringMoneyOutVersionDetails.payoutAmount": "Uitkeringsbedrag",
  "activeRecurringMoneyOutVersionDetails.receiverPersonId": "Ontvangende persoon-ID",
  "activeRecurringMoneyOutVersionDetails.relationshipType": "Relatie type",
  "addBankAccountModal.title": "Bankrekening toevoegen",
  "addFundMergeCommandData.fromDate": "Ingangsdatum",
  "addFundMergeCommandData.fundMerge.date": "Uitvoeringsdatum van de portfolio",
  "addFundMergeCommandData.fundMergedestinationIsinKey": "Naar ISIN sleutel",
  "addFundMergeCommandData.isinKey": "Van ISIN sleutel",
  "address.addresses": "Adressen",
  "address.city": "Woonplaats",
  "address.country": "Land",
  "address.field._type": "Soort",
  "address.field.abbreviatedCountryName": "Afgekorte landnaam",
  "address.field.addressCo": "Tijdelijk adres",
  "address.field.addressLine1": "Regel 1",
  "address.field.addressLine2": "Regel 2",
  "address.field.addressLine3": "Regel 3",
  "address.field.city": "Woonplaats",
  "address.field.country": "Land",
  "address.field.houseNumber": "Huisnummer",
  "address.field.isValid": "Is geldig",
  "address.field.numericalCountryCode": "Land",
  "address.field.postalCode": "Postcode",
  "address.field.relocationDate": "Verhuisdatum",
  "address.field.relocationInformationReceiveDate": "Verhuisinformatie ontvangen datum",
  "address.field.streetName": "Straatnaam",
  "address.postalCode": "Postcode",
  "addressCard.address1": "Adres 1",
  "addressCard.address2": "Adres 2",
  "addressCard.address3": "Adres 3",
  "addressCard.addressType": "Soort adres",
  "addressCard.city": "Woonplaats",
  "addressCard.country": "Land",
  "addressCard.postalCode": "Postcode",
  "addressCard.title": "Adres",
  "addressLink.field.addressLink": "Adres",
  "addressLink.field.addressLinks": "Adressen",
  "addressLink.field.addressType": "Soort adres",
  "advancedSearchCard.companyTab": "Bedrijf",
  "advancedSearchCard.internalAndExternalIdLookupTab": "Interne of externe ID opzoeken",
  "advancedSearchCard.internalIdLookupTab": "Interne ID opzoeken",
  "advancedSearchCard.personTab": "Persoon",
  "agreements.noAgreement": "overeenkomst",
  "agreements.noAppliedEvents.reason": "Selecteer een niet-toegepaste gebeurtenis om gegevens te zien.",
  "agreements.noEventSelected": "gebeurtenis geselecteerd.",
  "agreements.noEventSelected.reason": "Selecteer een gebeurtenis om gegevens te zien.",
  "agreementsSection.title": "Overeenkomsten",
  "ai.agent.activity.ranCommand": "{count} opdracht uitgevoerd",
  "ai.agent.activity.ranCommands": "{count} opdrachten uitgevoerd",
  "ai.agent.activity.usingTool": "Tool gebruiken",
  "ai.agent.chat.close": "Chat sluiten",
  "ai.agent.chat.input.placeholder": "Stel een vraag...",
  "ai.agent.chat.intro": "Hallo! Ik ben je AI-assistent. Hoe kan ik je helpen met dit commitment?",
  "ai.agent.chat.message.error": "Verzenden mislukt",
  "ai.agent.chat.retry": "Opnieuw proberen",
  "ai.agent.chat.send": "Verstuur",
  "ai.agent.chat.toggle": "AI-chat openen",
  "ai.agent.chat.typing": "Assistent is aan het typen…",
  "ai.commitment.summary": "AI-samenvatting",
  "ai.commitment.summary.error": "De AI-samenvatting kon niet worden voltooid.",
  "amendEmployerAgreementPolicies.label": "Beleid wijzigen",
  "amendEmployerAgreementPolicies.title": "Verander beleid",
  "amendEmployerAgreementPoliciesForm.actionOption": "Actietype",
  "amendEmployerAgreementPoliciesForm.adjustSalaryFromContribution": "Pas salaris aan van bijdrage",
  "amendEmployerAgreementPoliciesForm.applyDate": "Valutadatum",
  "amendEmployerAgreementPoliciesForm.policyDefaultSelected": "Polis standaard geselecteerd",
  "amendEmployerAgreementPoliciesForm.subTemplateIdentifier": "Subtemplate-ID",
  "amendEmployerAgreementPolicy.elementLabel": "Beleid wijzigen",
  "amountCreation.amountPerInstallment": "Bedrag per termijn",
  "amountCreation.dueDate": "Vervaldatum",
  "amountSpecVersionDetails.currentAmount": "Huidig bedrag",
  "amountSpecVersionDetails.currentAmountDocumentation": "Documentatie huidig bedrag",
  "amountSpecVersionDetails.fraction": "Fractie",
  "amountSpecVersionDetails.fractionDocumentation": "Documentatie fractie",
  "amountSpecVersionDetails.parameterAmount": "Parameter bedrag",
  "amountSpecVersionDetails.parameterAmountDocumentation": "Documentatie parameter bedrag",
  "amountSpecVersionDetails.parameterKey": "Parameter",
  "amountSpecVersionDetails.parameterKeyDocumentation": "Documentatie parameter",
  "amountSpecVersionDetails.parameterValue": "Parameter waarde",
  "amountSpecVersionDetails.parameterValueDocumentation": "Documentatie parameter waarde",
  "annotation.accessGroupAnnotation.group": "Toegangsgroep",
  "annotation.applyDate": "Toepassingsdatum",
  "annotation.groups.group": "Groep",
  "annotation.groups.title": "Annotatiegroepen",
  "annotation.search.entity": "Entiteit",
  "annotation.search.title": "Annotaties zoeken",
  "app.title": "Zaakbehandelaar",
  "appliedEventsTable.itemName": "Gebeurtenissen",
  "applyScenarioModal.title": "Scenario toepassen",
  "applyScenarioModal.warning": "Weet je zeker dat je dit scenario wilt toepassen?",
  "approve": "Goedkeuren",
  "approvePendingCancellation": "Annulering goedkeuren",
  "assignOwnerModal.newOwnerSsnLabel": "Nieuwe eigenaar",
  "assignOwnerModal.title": "Eigenaar toewijzen",
  "balancePostingsFilter.postingTypes": "Type boeking",
  "balancePostingsFilter.resultLimit": "Resultaatlimiet",
  "balancePostingsFilter.transactionTime": "Transactiedatum",
  "balancePostingsFilter.valueDate": "Valutadatum",
  "batch.create": "Aanmaken",
  "batch.fromTemplate": "Creeer batch van template",
  "batchDetailedView.createdBy": "Gemaakt door",
  "batchDetailedView.id": "Batch-ID",
  "batchDetailedView.select": "Geselecteerde batch:",
  "batchDetailedView.status": "Batch Status:",
  "batchDetailedView.stopBatch": "Batch stoppen",
  "batchError.100max": "100 max",
  "batchError.10max": "10 max",
  "batchError.custom": "Aangepast",
  "batchErrors.download": "Download",
  "batchStatistics.average": "Gemiddelde",
  "batchStatistics.completeJobWaitDurationStatistics": "Volledige wachttijdstatistieken",
  "batchStatistics.completeStatistics": "Volledige statistieken",
  "batchStatistics.duration": "Duur (ms)",
  "batchStatistics.enumerationDuration": "Enumeratieduur (ms)",
  "batchStatistics.execution": "Uitvoering",
  "batchStatistics.jobTimeoutCount": "Aantal jobtime-outs",
  "batchStatistics.maximum": "Maximum",
  "batchStatistics.minimum": "Minimum",
  "batchStatistics.p50": "P50",
  "batchStatistics.p95": "P95",
  "batchStatistics.p99": "P99",
  "batchStatistics.sampleCount": "Aantal metingen",
  "batchStatistics.title": "Batchstatistieken",
  "batchStatistics.unavailable": "Er zijn geen statistieken beschikbaar voor deze batch.",
  "batchStatistics.waitTime": "Wachttijd",
  "batchStatus.activityFrom": "Activiteit van",
  "batchStatus.activityTo": "Activiteit tot",
  "batchStatus.batchStatusType": "Status",
  "batchStatus.col.created": "Gemaakt",
  "batchStatus.col.duration": "Tijd (min)",
  "batchStatus.col.ended": "Beëindigd",
  "batchStatus.col.entityCount": "Entiteit telling",
  "batchStatus.col.errorCount": "Fouten",
  "batchStatus.col.name": "Naam",
  "batchStatus.col.progressPct": "Voortgang %",
  "batchStatus.col.progressVal": "Voortgang #",
  "batchStatus.col.started": "Gestart",
  "batchStatus.col.status": "Status",
  "batchStatus.details": "Details",
  "batchStatus.noRestriction": "Geen beperking",
  "batchStatus.specificationType": "Type",
  "birthOrDeathDate.birthdate": "Geboortedatum",
  "birthOrDeathDate.deathdate": "Overlijdensdatum",
  "birthdateChangeButton.birthDate": "Geboortedatum",
  "birthdateChangeButton.birthDateValueDate": "Toepassingsdatum",
  "birthdateChangeButton.button": "Wijzigen geboortedatum",
  "bundlingStops.moneyIn.modalTitle": "Aanmaak factuur stop",
  "cancelInstallmentPlan.description": "Ben je zeker dat je het afbetalingsplan wilt annuleren? Deze actie kan niet ongedaan worden gemaakt.",
  "cancelInstallmentPlan.title": "Afbetalingsplan annuleren",
  "card.field.informationSource": "Informatiebron",
  "ccInput.column.creationStamp": "Gemaakt",
  "ccInput.column.inputId": "Input-ID",
  "ccInput.column.valueDate": "Valutadatum",
  "ccLifeInput.title": "Historische input",
  "ccStates.column.calcType": "Soort berekening",
  "ccStates.column.creationStamp": "Gemaakt",
  "ccStates.column.inputId": "Input-ID",
  "ccStates.column.status": "Status",
  "ccStates.column.valid": "Is geldig",
  "ccStates.column.valueDate": "Valutadatum",
  "ccStates.title": "Lijst met CCD-runs",
  "ccStatesTable.advancedExcelExport.title": "CCD-uitvoer inspecteren",
  "ccStatesTable.excelExport.title": "CCD-berekeningen inspecteren",
  "ccStatesTable.generalConfirmation.title": "Bevestig dat de gegevens naar het pensioenadministratiesysteem moeten worden verzonden",
  "ccStatesTable.generalDescription.title": "Weet u zeker dat u de opbrengsten en boekingen naar het pensioenadministratiesysteem wilt sturen?",
  "ccStatesTable.lifeConfirmation.title": "Bevestig dat de gegevens naar Life moeten worden verzonden",
  "ccStatesTable.lifeDescription.title": "Weet u zeker dat u de opbrengsten en boekingen naar Life wilt sturen?",
  "ccdCalculation.title": "CCD-berekening",
  "ccdFilterForm.inputId": "Input-ID",
  "changeCommitmentModalButton.confirm.added": "Toegevoegd",
  "changeCommitmentModalButton.confirm.body": "Weet u zeker dat u de volgende wijzigingen wilt toepassen? Dit kan alleen als de simulatie is voltooid.",
  "changeCommitmentModalButton.confirm.field": "Veld",
  "changeCommitmentModalButton.confirm.noChanges": "Geen veranderingen",
  "changeCommitmentModalButton.confirm.removed": "Verwijderd",
  "changeCommitmentModalButton.confirm.simulationFailure": "Simulatie mislukt. De volgende fouten moeten opgelost worden alvorens de command toe te passen:",
  "changeCommitmentModalButton.confirm.simulationPending": "Simulatie in behandeling",
  "changeCommitmentModalButton.confirm.simulationSuccess": "Simulatie voltooid",
  "changeCommitmentModalButton.confirm.title": "Bevestig toezeggingswijziging",
  "changeCommitmentModalButton.title": "Wijzig oa Polis, dekking en status",
  "changeContributionData.input.applyDate": "Toepassingsdatum",
  "changeContributionData.input.billingFrequency": "Factureringsfrequentie",
  "changeContributionData.input.paidInArrears": "Achteraf betaald",
  "changeContributionData.title": "Bijdragegegevens",
  "changeLegalEntityCommand.confirm.body": "Weet u zeker dat u de volgende wijzigingen wilt toepassen?",
  "changeLegalEntityCommand.confirm.title": "Bevestig legalentity wijziging",
  "changeTemplateSource.input.applyDate": "Toepassingsdatum",
  "changeTemplateSource.input.templateSourceId": "Sjabloonbron-ID",
  "changeTemplateSourceCommand.title": "Bron sjabloon",
  "clearStops.description": "De volgende onderdelen kunnen of hebben een vlag",
  "clearStops.doNotCatchUp": "Niet inhalen",
  "clearStops.employerAgreement.title": "Werkgeverovereenkomst stops",
  "collCalc.ccCalcType": "Soort berekening",
  "collCalc.details":
    "Deze pagina toont een reeks opbrengsten en een reeks overeenkomstige opbrengsten en boekingen voor de collectieve potten. Deze zijn het resultaat van berekeningen uitgevoerd op collectief niveau, waarbij de collectieve kapitaalverdeling onder SPR en FPR wordt afgehandeld, evenals de aanpassing van de voordelen in de collectieve uitkeringsfase.\nDe berekeningen zijn gebaseerd op de input van het pensioenadministratiesysteem en de vermogensbeheerder (hier geüpload als Excel-bestand) en de resultaten worden verzonden naar het pensioenadministratiesysteem. Een deel van de opbrengsten zijn: rentebescherming en overmaat, microbiometrische bescherming en overmaat, overschot en aanvulling. De volgorde van berekeningen, frequentie en formules zijn volledig configureerbaar.",
  "collCalc.sheet": "Excel sheet",
  "collectivePots.account": "Rekening",
  "collectivePots.accountType": "Enkelvoudige rekening",
  "collectivePots.action.addBalancePosting": "Toevoegen collectieve saldo boekingen",
  "collectivePots.action.editBalancePosting": "Wijzigen balance posteringer",
  "collectivePots.balance": "Saldo",
  "collectivePots.balancePostings": "Saldo boekingen",
  "collectivePots.column.balance": "Saldo",
  "collectivePots.column.delta": "Delta",
  "collectivePots.column.endDate": "Einddatum",
  "collectivePots.column.startDate": "Startdatum",
  "collectivePots.description": "Omschrijving",
  "collectivePots.draftWorkPads": "Voorlopige werkbladen",
  "collectivePots.netAmount": "Netto bedrag",
  "command.isScenario": "Scenario",
  "commandData.approvedBy": "Goedgekeurd door",
  "commandData.cancel": "Terugdraaien mutatie",
  "commandData.cancel.body": "Annuleren van een commando draait al zijn wijzigingen terug. Zorg ervoor dat dit de bedoeling is, voordat je bevestigt.",
  "commandData.cancel.title": "Weet je zeker dat je wilt annuleren: {title}?",
  "commandData.cancelledApprovedBy": "Geannuleerd goedgekeurd door",
  "commandData.cancelledBy": "Geannuleerd door",
  "commandData.createdBy": "Aangemaakt door",
  "commandData.description": "Een laag nummer = hoge prioriteit.",
  "commandData.notAllowedToApproveOwnCommands": "Je hebt geen toestemming om je eigen commando's goed te keuren.",
  "commandData.onlyScenarioCommandAllowed": "Het is alleen mogelijk om acties uit te voeren op opdrachten die in een scenario zijn aangemaakt.",
  "commandData.priority": "Prioriteit",
  "commandData.reasonForBeingUnapplied": "Reden voor niet-toepassing",
  "commandData.reasonForBeingUnapplied.approvalPending": "Goedkeuring in afwachting",
  "commandData.reasonForBeingUnapplied.cancelApprovalPending": "Annuleer goedkeuring in afwachting",
  "commandData.reasonForBeingUnapplied.futureApplyDate": "Toekomstige toepassingsdatum",
  "commandData.reasonForBeingUnapplied.missingPersons": "Ontbrekende personen",
  "commandEventsGraph.tooltip.around": "Rondom",
  "commandEventsGraph.tooltip.from": "Van",
  "commandEventsGraph.tooltip.to": "Tot",
  "commandExclustionToggle.tooltip": "Toevoegen command bij toepassen van scenario",
  "commandModalButton.deflateCommitmentVersion": "Inflatie gecorrigeerde simulatie",
  "commandModalButton.hoverAlertToSeeErrorDetails": "Beweeg over de waarschuwing om foutdetails te zien.",
  "commandModalButton.simulate": "Simuleer",
  "commandModalButton.unableToEditToDoCriticalError.body": "Verwijder het commando en maak het opnieuw aan.",
  "commandModalButton.unableToEditToDoCriticalError.title": "Het portaal kan bewerken niet ondersteunen vanwege een kritieke fout.",
  "commandModalButton.viewError.body": "Acties zijn nog steeds beschikbaar ondanks de fout. Hieronder kunt u alle beschikbare gegevens voor dit commando zien.",
  "commandModalButton.viewError.title": "Er is een onverwachte fout opgetreden",
  "commandPalette.group.favourites.add": "",
  "commandPalette.group.favourites.remove": "",
  "commandPalette.group.favourites.tooltip.hide": "Verberg favorieten in deze groep",
  "commandPalette.group.favourites.tooltip.show": "Toon favorieten in deze groep",
  "commandPalette.group.unauthorized.tooltip.hide": "Verberg niet-geautoriseerde in deze groep",
  "commandPalette.group.unauthorized.tooltip.show": "Toon niet-geautoriseerde in deze groep",
  "commandPalette.group.warnings.tooltip.hide": "Verberg waarschuwingen in deze groep",
  "commandPalette.group.warnings.tooltip.show": "Toon waarschuwingen in deze groep",
  "commandPalette.placeholder": "Begin met typen...",
  "commandTable.column.appliedStatus": "Toegepast",
  "commandTable.column.applyDate": "Toepassingsdatum",
  "commandTable.column.approvedBy": "Goedgekeurd door",
  "commandTable.column.cancelApprovedBy": "Annuleer goedkeuring door",
  "commandTable.column.cancelledBy": "Geannuleerd door",
  "commandTable.column.cancelledStatus": "Geannuleerd",
  "commandTable.column.cancelledTime": "Annuleringsdatum",
  "commandTable.column.commandTemplateId": "Stap",
  "commandTable.column.createdBy": "Aangemaakt door",
  "commandTable.column.createdTime": "Aangemaakt op",
  "commandTable.column.expectedApplyDate": "Verwacht toepassingsdatum",
  "commandTable.column.information": "Informatie",
  "commandTable.column.rolledBackStatus": "Terug gerold",
  "commandTable.column.status": "Toestand",
  "commandTable.column.unappliedCommand": "Niet toegepaste command's",
  "commandTable.title": "Gebeurtenis",
  "commitment.dateSelector.label": "Bekijk toezegging op",
  "commitment.layout.navigation.covers": "Dekkingen",
  "commitment.layout.navigation.events": "Gebeurtenissen",
  "commitment.layout.navigation.home": "Home",
  "commitment.layout.navigation.moneyInInvoices": "Facturen",
  "commitment.layout.navigation.paymentReceiver": "Betalingsontvanger",
  "commitment.layout.navigation.paymentsIn": "Incasso",
  "commitment.layout.navigation.paymentsOut": "Excasso",
  "commitment.layout.navigation.personInformation": "Persoonsinformatie",
  "commitment.layout.navigation.policy": "Polissen",
  "commitment.layout.navigation.portfolio": "Portfolio",
  "commitment.layout.navigation.relatedCommitments": "Gerelateerde toezeggingen",
  "commitment.layout.navigation.scenarios": "Scenario's",
  "commitment.layout.navigation.workbench": "Details",
  "commitmentOverview.information.retirementCard.retirementDate": "Pensioendatum",
  "commitmentOverview.information.retirementCard.retirementFraction": "Percentage pensionering",
  "commitmentOverview.information.retirementCard.title": "Pensioengegevens",
  "commitmentRegressionSpecification.commitmentRegressionCompareDefinitionTemplateId": "Toezegging regression vergelijkingsdefinitie sjabloon-ID",
  "commitmentRegressionSpecification.coverRegressionCompareDefinitionTemplateId": "Dekking regression vergelijkingsdefinitie sjabloon-ID",
  "commitmentRegressionSpecification.fromDate": "Van datum",
  "commitmentRegressionSpecification.policyRegressionCompareDefinitionTemplateId": "Polissen regression vergelijkingsdefinitie sjabloon-ID",
  "commitmentScenario.form.newFieldInfo": "De opgegeven titel bestaat niet en zal resulteren in een nieuwe creatie",
  "commitmentScenario.form.scenario": "Scenario",
  "commitmentScenario.form.variant": "Variant",
  "commitmentScenario.modal.add": "Toevoegen aan scenario: {scenarioTitle}, {variantTitle}",
  "commitmentScenario.modal.addUnknown": "Toevoegen aan scenario",
  "commitmentScenario.modal.create": "Aanmaken/toevoegen aan scenario",
  "commitmentSource.commitmentTime": "Toezegging tijd {commitmentTime}",
  "commitmentStart.startDate": "Klant sinds {startDate}",
  "commitmentStatus.status": "Inzet Status",
  "company.layout.navigation.agreements": "Overeenkomsten",
  "company.layout.navigation.home": "Home",
  "company.layout.navigation.legalentity": "Bedrijfsinformatie",
  "company.layout.navigation.moneyInInvoices": "Facturen",
  "companyInformationCard.endDate": "Einddatum",
  "companyInformationCard.foundationDate": "Startdatum",
  "companyInformationCard.name": "Naam",
  "companyInformationCard.title": "Bedrijf informatie",
  "companySearchForm.similarName": "Naam lijkt op",
  "companySearchResultsCard.column.addresses": "Adressen",
  "companySearchResultsCard.column.externalId": "KVK",
  "companySearchResultsCard.column.internalId": "Interne ID",
  "companySearchResultsCard.column.name": "Naam",
  "companySection.endDate": "Einddatum",
  "companySection.externalId": "Externe ID",
  "companySection.foundationDate": "Startdatum",
  "companySection.internalId": "Interne ID",
  "component.legalentity": "Legalentity",
  "component.life": "Life",
  "component.moneyin": "Money in",
  "component.moneyout": "Money out",
  "component.unitlink": "UnitLink",
  "contributionData.billingFrequency": "Betalingsfrequentie",
  "contributionData.paidInArreas": "Achteraf betaald",
  "copyVariantModal.commands": "Commando's om te kopieren",
  "copyVariantModal.copyNewVariant": "Make new copy: {variantTitle}",
  "copyVariantModal.copyToVariant": "Copy to: {variantTitle}",
  "copyVariantModal.noCommands": "Geen commando's om te kopieren.",
  "copyVariantModal.selectVariant": "Variant name to copy to",
  "count": "Aantal: {count}",
  "cover.riskEndDate": "Einddatum",
  "coverColumn.benefitEnd": "Uitkering eind",
  "coverColumn.benefitParameter": "Voordeelbasis",
  "coverColumn.billingBalance": "Factureringssaldo",
  "coverColumn.calculatedBenefit": "Uitkering",
  "coverColumn.claimBalance": "Claim kapitaal",
  "coverColumn.coInsured": "Medeverzekerde",
  "coverColumn.contribFraction": "Percentage",
  "coverColumn.contribPriority": "Prioriteit",
  "coverColumn.coverKey": "Id",
  "coverColumn.coverProductType": "Product",
  "coverColumn.coverStatus": "Status",
  "coverColumn.moneyOutEndDate": "Einddatum",
  "coverColumn.moneyOutType": "Type",
  "coverColumn.originalExternalsecondaryId": "Oorspronkelijke eigenaar",
  "coverColumn.premiumAmount": "Premie bedrag",
  "coverColumn.premiumPct": "Premie pct",
  "coverColumn.productName": "Productnaam",
  "coverColumn.receiverPerson": "Ontvanger",
  "coverColumn.relatedToCoverKey": "Gerelateerd aan dekking",
  "coverColumn.riskBenefitAmount": "Uitkering",
  "coverColumn.riskBenefitPct": "Uitkering pct",
  "coverColumn.riskBenefitTriggers": "Dekking bij",
  "coverColumn.riskEndDate": "Einde dekking",
  "coverColumn.savingsBalance": "Kapitaal",
  "coverColumn.taxCode": "Belasting code",
  "coverColumn.unitlinkStatus": "Status UnitLink",
  "coverColumn.yearlyPremiumParameter": "Premiebasis",
  "coverDetails.activeRecurringMoneyOutVersion": "Actieve terugkerende betalingen",
  "coverDetails.billingFrequency": "Betaaltermijn",
  "coverDetails.coverKey": "Dekking",
  "coverDetails.coverProductType": "Product",
  "coverDetails.coverStatus": "Status dekking",
  "coverDetails.fromDate": "Vanaf datum",
  "coverDetails.insured": "Verzekerde",
  "coverDetails.moneyInTaxCode": "Belastingcode incasso",
  "coverDetails.originalExternalsecondaryId": "Originele externe secundaire ID",
  "coverDetails.policyKey": "Polis",
  "coverDetails.premium": "Premie",
  "coverDetails.sortPriority": "Sorteer prioriteit",
  "coverDetails.tenantSubGroup": "Fonds subgroep",
  "coverDetails.title": "Details dekking",
  "coverDetails.unitlinkStatus": "Status UnitLink",
  "coverDetails.yearlyPremium": "Jaarlijkse premie",
  "coverDetailsModal.title": "Details dekking",
  "coverLayerVersion.benefit": "Uitkering",
  "coverLayerVersion.name": "Naam",
  "coverLayerVersion.tariffId": "Tarief-ID",
  "coverList.activeRiskCovers": "Uitkerende risicodekking",
  "coverList.activeSavingsCovers": "Uitkerende kapitaal pensioenen",
  "coverList.balancePostings": "Saldo boekingen",
  "coverList.riskCoverType": "Risico",
  "coverList.riskCovers": "Risicodekkingen",
  "coverList.savingsCoverType": "Kapitaalopbouw",
  "coverList.savingsCoverWithBalance": "Kapitaalopbouw dekkingen met saldo",
  "coverList.savingsCovers": "Kapitaalopbouw dekkingen",
  "coverSimulation.title": "Dekkingen",
  "coversSimulation.aggregated": "Geaggregeerd",
  "coversSimulation.detailedView": "Gedetailleerde weergave",
  "coversTable.column.balance": "Saldo",
  "coversTable.column.beneficiaryEndAge": "tot {age}",
  "coversTable.column.benefit": "Uitkering",
  "coversTable.column.benefitEnd": "Uitkering eind",
  "coversTable.column.coverKey": "Dekking",
  "coversTable.column.coverProductType": "Product",
  "coversTable.column.coverStatus": "Status",
  "coversTable.column.coverType": "Type",
  "coversTable.column.insured": "Verzekerde",
  "coversTable.column.lifeInsuranceEvents": "Verzekeringsevenementen",
  "coversTable.column.moneyOutLength": "in {years}",
  "coversTable.column.moneyOutType": "Excasso type",
  "coversTable.column.policyKey": "Police",
  "coversTable.column.riskEndDate": "Einddatum risico",
  "coversTabsCard.allCovers": "Alle dekkingen",
  "createAgreement.applyDate": "Toepassingsdatum",
  "createAgreement.commitmentTemplateId": "Verbintenis-sjabloon-ID",
  "createAgreement.companyId": "Bedrijf-ID",
  "createAgreement.contributionData": "Bijdragegegevens",
  "createAgreement.employerAgreementId": "Werkgeversovereenkomst-ID",
  "createAgreement.name": "Naam",
  "createAgreement.templateSourceId": "Sjabloonbron-ID",
  "createAgreement.title": "Overeenkomst creëren",
  "createAgreement.toDate": "Tot datum",
  "createCommitmentModalButton.template": "Sjabloon",
  "createCommitmentModalButton.title": "Aanmaken toezegging",
  "createCompany.address": "Adres",
  "createCompany.addresses": "Adressen",
  "createCompany.button": "Creeer bedrijf",
  "createCompany.companyId": "Bedrijf-ID",
  "createCompany.name": "Naam",
  "createInstallmentPlan.installment": "Afbetaling {index}",
  "createInstallmentPlan.installmentTotal": "Afdrag totaal",
  "createInstallmentPlan.installments": "Afbetalingen",
  "createInstallmentPlan.invoiceTotal": "Factuur totaal",
  "createInstallmentPlan.invoices": "Facturen",
  "createInstallmentPlan.remainingAmount": "Restbedrag",
  "createInstallmentPlan.title": "Afbetalingsplan",
  "createInstallmentPlanform.creationMethod.byAmount": "Vast bedrag",
  "createInstallmentPlanform.creationMethod.byInstallments": "Aantal termijnen",
  "createInstallmentPlanform.creationMethod.manual": "Handmatig",
  "createInvoiceElementsInvoice.aggregatedAmount": "Geaggregeerd bedrag",
  "createInvoiceElementsInvoice.negative": "Negatief",
  "createInvoiceElementsInvoice.numAmounts": "Aantal bedragen",
  "createInvoiceElementsInvoice.positive": "Positief",
  "createInvoiceElementsInvoice.title": "Factuur maken op basis van factuurelementen",
  "createInvoiceElementsInvoice.total": "Totaal",
  "createLegalEntityModalButton.button": "Aanmaken klant",
  "createLegalEntityModalButton.externalId": "Externe ID",
  "createLegalEntityModalButton.pseudoExternalId": "Pseudo BSN",
  "createPersonCommandData.birthdate": "Geboortedatum",
  "createPersonCommandData.firstName": "Voornaam",
  "createPersonCommandData.gender": "Geslacht",
  "createPersonCommandData.initials": "Initialen",
  "createPersonCommandData.lastName": "Achternaam",
  "createPersonCommandData.nationality": "Nationaliteit",
  "createPolicyModalButton.fromDate": "Startdatum",
  "createPolicyModalButton.policyTemplateId": "Polissjabloon-ID",
  "createPolicyModalButton.title": "Aanmaken polis",
  "darkModeSwitcher.label": "Thema",
  "deathButton.deathDate": "Overlijdensdatum",
  "deathButton.title": "Overlijden",
  "deathClaims.addDeathClaim": "Nabestaandenpensioen toekennen",
  "deathClaims.benefit": "Uitkering",
  "deathClaims.covers": "Dekkingen",
  "deathClaims.policy": "Polis",
  "deathClaims.receiverName": "Begunstigde",
  "deathClaims.receivers": "Begunstigden",
  "deathClaims.relationshipType": "Relatie",
  "deathClaims.relationshipType.receiver": "Relatie met overledene",
  "deathClaims.senderName": "Overledene",
  "deathClaimsCard.title": "Nabestaandenpensioen",
  "declinePendingCancellation": "Verzoek tot annulering verwijderen",
  "deleteCommitmentSourceExternalPayloadModalButton.title": "Verwijder commitment source external payload",
  "deleteScenarioModal.title": "Scenario verwijderen",
  "deleteScenarioModal.warning": "Weet u zeker dat u het scenario wilt verwijderen?",
  "deleteVariantModal.title": "Scenariovariant verwijderen",
  "deleteVariantModal.warning": "Weet u zeker dat u de scenariovariant wilt verwijderen?",
  "disabilityLane.fallbackTitle": "Arbeidsongeschiktheid",
  "disablePenaltiesInvoice.field.disableFromDate": "Van datum",
  "divorceButton.endDate": "Echtscheidingsdatum",
  "divorceButton.title": "Echtscheiding",
  "download.commitmentRegression.title": "Download toezegging regression",
  "download.commitmentSource.title": "Download toezegging bron (.json)",
  "download.employerAgreementSource.title": "Download werkgeversovereenkomst (.json)",
  "download.exportCommitmentButton.button": "Commitment (.xlsm)",
  "download.exportCommitmentButton.title": "Exporteren commitment (.xlsm)",
  "download.exportEmployerAgreement.button": "Werkgeversovereenkomst (.xlsm)",
  "download.exportGlPostingsOriginalButton.title": "GL-boekingen downloaden (origineel)",
  "download.exportInvoice.button": "Factuur (.xlsm)",
  "download.exportMoneyInButton.title": "Exporteren incasso (.xlsm)",
  "download.exportMoneyOutButton.title": "Exporteren excasso (.xlsm)",
  "download.exportPersonSourceExcelSheet.button": "Persoonlijke bron (.xlsm)",
  "download.exportPortfolioButton.button": "Portefølje (.xlsm)",
  "download.exportReconciliationReportButton.title": "Reconciliatierapport exporteren",
  "download.legalEntitySource.button": "Rechtspersoon (.json)",
  "draftWorkPad.approve.description": "Weet je zeker dat je het werkblad wilt workpad?",
  "draftWorkPad.approve.title": "Goedkeuren",
  "draftWorkPad.approved": "Goedgekeurd",
  "draftWorkPad.creationStamp": "Gemaakt",
  "draftWorkPad.creationUserId": "Gemaakt door",
  "draftWorkPad.delete.description": "Weet je zeker dat je het werkblad wilt workpad?",
  "draftWorkPad.delete.title": "Verwijderen",
  "draftWorkPad.deleted": "Verwijderd",
  "draftWorkPad.includeDeleted": "Toon verwijderde",
  "draftWorkPad.undelete.description": "Weet je zeker dat je het verwijderen van het werkblad wilt ongedaan workpad?",
  "draftWorkPad.undelete.title": "Herstellen",
  "editBankAccountModal.title": "Bankrekening bewerken",
  "editFundCommandSelectionModal.fraction": "Fractie",
  "editFundCommandSelectionModal.fund": "Fonds",
  "editFundCommandSelectionModal.isinKey": "Fond",
  "editPartitionCommandSelectionModal.fraction": "Fractie",
  "editPartitionCommandSelectionModal.partition": "Partition",
  "editPartitionCommandSelectionModal.profileType": "Profieltype",
  "editPortfolioModalButton.title": "Geavanceerd portfoliobeheer",
  "employerAgreement.agreementName": "Overeenkomstnaam",
  "employerAgreement.companyId": "Bedrijf-ID",
  "employerAgreement.contribution.billingFrequency": "Betaaltermijn",
  "employerAgreement.contribution.paidInArreas": "Achteraf betaald",
  "employerAgreement.contribution.title": "Bijdrage",
  "employerAgreement.cover.benefit": "Standaard bijdrage",
  "employerAgreement.cover.coverId": "Dekking-ID",
  "employerAgreement.cover.events": "Gebeurtenissen",
  "employerAgreement.cover.maxBenefit": "Maximale uitkering",
  "employerAgreement.cover.minBenefit": "Minimale uitkering",
  "employerAgreement.cover.selected": "Standaard geselecteerd",
  "employerAgreement.cover.type": "Soort",
  "employerAgreement.covers.title": "Dekkingen",
  "employerAgreement.employeeAgreementTemplateId": "Overeenkomstsjabloon-ID",
  "employerAgreement.employerAgreementId": "Overeenkomst-ID",
  "employerAgreement.fromDate": "Aanmaakdatum",
  "employerAgreement.moneyIn.actionRequired": "Actie vereist",
  "employerAgreement.moneyIn.amount": "Bedrag",
  "employerAgreement.moneyIn.isPaid": "Geconsolideerd",
  "employerAgreement.moneyIn.person": "Persoon",
  "employerAgreement.name": "Overeenkomstnaam",
  "employerAgreement.period": "Periode",
  "employerAgreement.policyDetailsCard.defaultSelected": "Standaard geselecteerd",
  "employerAgreement.policyDetailsCard.template": "Sjabloon",
  "employerAgreement.policyDetailsCard.title": "Polis details",
  "employerAgreement.status": "Status",
  "employerAgreement.title": "Werkgever overeenkomst",
  "employerAgreementsTable.title": "Werkgeversovereenkomsten",
  "employment.actions.details": "Details",
  "employment.actions.salaryPeriods": "Salaris periodes",
  "employment.agreementId": "Overeenkomst",
  "employment.benefitBase": "Basis berekening",
  "employment.billingFrequency": "Betaaltermijn",
  "employment.command.modal.agreementId": "Overeenkomst-ID",
  "employment.command.modal.changeDate": "Wijzigingsdatum",
  "employment.command.modal.commitmentId": "Commitment-ID",
  "employment.command.modal.companyName": "Bedrijfsnaam",
  "employment.command.modal.employmentId": "Dienstverband-ID",
  "employment.command.modal.endDate": "Einddatum",
  "employment.details.title": "Dienstverband details",
  "employment.employerId": "Werkgever-ID",
  "employment.employmentEnd": "Einde dienstverband",
  "employment.employmentId": "Dienstverband-ID",
  "employment.employmentStart": "Aanvang dienstverband",
  "employment.movement.premium": "Premie",
  "employment.movement.salary": "Salaris",
  "employment.movement.salaryPartTimePct": "Salaris parttime percentage",
  "employment.movement.salaryPeriodEnd": "Einde salaris periode",
  "employment.movement.salaryPeriodStart": "Start salaris periode",
  "employment.paidInArrears": "Achteraf betaald",
  "employment.partTimePercentage": "Parttime percentage",
  "employment.title": "Dienstverbanden",
  "employment.yearlyPensionableSalary": "Pensioengevend jaarsalaris",
  "employment.yearlySalary": "Jaarsalaris",
  "employmentOverview.billingFrequency": "{frequency} betaling",
  "employmentRow.details": "Details",
  "enum.ActionOption.CreateEmployerAgreementPolicySelectionData": "Maak beleid aan",
  "enum.ActionOption.DeleteEmployerAgreementPolicySelectionData": "Verwijder beleid",
  "enum.ActionOption.UpdateEmployerAgreementPolicySelectionData": "Werk beleid bij",
  "enum.ActionWarningCode.aboveEligibleAge": "Boven de in aanmerking komende leeftijd",
  "enum.ActionWarningCode.alreadyApplied": "Reeds toegepast",
  "enum.ActionWarningCode.expectedCommitmentStatus": "Verwachte commitment status",
  "enum.ActionWarningCode.expectedDateAfter": "Verwachte datum achteraf",
  "enum.ActionWarningCode.hasActivePartner": "Heeft actieve partner",
  "enum.ActionWarningCode.hasField": "Heeft",
  "enum.ActionWarningCode.missingField": "Mist",
  "enum.ActionWarningCode.noActivePartner": "Geen actieve partner",
  "enum.ActionWarningCode.noPartner": "Geen partner",
  "enum.ActionWarningCode.notScenario": "Geen scenario",
  "enum.ActionWarningCode.unexpectedCommitmentStatus": "Onverwachte commitment status",
  "enum.ActionWarningCode.unexpectedInvoiceStatus": "Onverwachte factuurstatus",
  "enum.ActionWarningCode.unexpectedPolicyStatus": "Onverwachte polisstatus",
  "enum.CommandTemplateId.AddBalancePostingsCommand": "Toevoegen saldo boekingen",
  "enum.CommandTemplateId.DeathClaimOrphanCommand": "Overlijdensclaim wees",
  "enum.CommandTemplateId.HandleMoneyInCommand": "Behandel inkomend geld command",
  "enum.CommandTemplateId.NewPolicyCommand": "Nieuwe polis",
  "enum.CommandTemplateId.NlValueTransferInCommand": "Waardeoverdracht in",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStep": "Einde vrijwillige bijdrage (art. 54 PW)",
  "enum.CommandTemplateId.NlVoluntaryContributionEndStepV2": "Einde vrijwillige bijdrage (art. 54 PW)",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStep": "Start vrijwillige bijdrage (art. 54 PW)",
  "enum.CommandTemplateId.NlVoluntaryContributionStartStepV2": "Start vrijwillige bijdrage (art. 54 PW)",
  "enum.CommandTemplateId.NlVoluntaryContributionUpdateStep": "Update vrijwillige bijdrage (art. 54 PW)",
  "enum.CommandTemplateId.RetirementCommand": "Pensionering command",
  "enum.ExternalPayloadEvent.ExternalPayloadConversionEvent": "Geconverteerd van oude registratie",
  "enum.ExternalPayloadEvent.ExternalPayloadCreatedEvent": "Aangemaakt",
  "enum.ExternalPayloadEvent.ExternalPayloadManualStatusChangeEvent": "Status handmatig gewijzigd",
  "enum.ExternalPayloadEvent.ExternalPayloadProcessedEvent": "Verwerkt",
  "enum.ExternalPayloadEvent.ExternalPayloadProcessingStartedEvent": "Verwerking gestart",
  "enum.ExternalPayloadEvent.ExternalPayloadRegisteredEvent": "Geregistreerd",
  "enum.ExternalPayloadEvent.ExternalPayloadRejectedEvent": "Afgewezen",
  "enum.ExternalPayloadEvent.ExternalPayloadRollbackEvent": "Teruggedraaid",
  "enum.ExternalPayloadEvent.ExternalPayloadSentEvent": "Verzonden",
  "enum.ExternalPayloadEvent.ExternalPayloadUpdateRejectedEvent": "Update afgewezen",
  "enum.ExternalPayloadEvent.ExternalPayloadUpdatedEvent": "Bijgewerkt",
  "enum.Persona.AdvisorAllan": "Adviseur Allan",
  "enum.Persona.AgreementAnnie": "Overeenkomst Annie",
  "enum.Persona.CommitmentCamilla": "Toezegging Camilla",
  "enum.Persona.DeathDennis": "Overlijden Dennis",
  "enum.Persona.FrontOfficeFrida": "Front Office Frida",
  "enum.Persona.HealthHeather": "Gezondheid Heather",
  "enum.Persona.MoneyInMark": "Incasso Mark",
  "enum.Persona.MoneyOutMichael": "Excasso Michael",
  "enum.Persona.RetirementRita": "Pensionering Rita",
  "enum.Persona.TaskListTeddy": "Takenlijst Teddy",
  "enum.PolicyType.PLACEHOLDER": "Tijdelijke aanduiding",
  "enum.PostingDimensions.dim1": "Dim 1",
  "enum.PostingDimensions.dim2": "Dim 2",
  "enum.PostingDimensions.dim3": "Dim 3",
  "enum.PostingDimensions.dim4": "Dim 4",
  "enum.PostingDimensions.dim5": "Dim 5",
  "enum.PostingDimensions.dim6": "Dim 6",
  "enum.PostingDimensions.dim7": "Dim 7",
  "enum.PostingDimensions.dim8": "Dim 8",
  "enum.PostingDimensions.key1": "Key 1",
  "enum.PostingDimensions.key2": "Key 2",
  "enum.PostingDimensions.key3": "Key 3",
  "enum.PostingDimensions.key4": "Key 4",
  "enum.SearchCategories.agreement": "Overeenkomsten",
  "enum.SearchCategories.changes": "Veranderingen",
  "enum.SearchCategories.collectiveCalculations": "Collectieve berekeningen",
  "enum.SearchCategories.common": "Algemeen",
  "enum.SearchCategories.company": "Bedrijf",
  "enum.SearchCategories.contributionHandling": "Bijdrage afhandeling",
  "enum.SearchCategories.death": "Overlijden",
  "enum.SearchCategories.disabilityAndSickness": "Arbeidsongeschiktheid en ziekte",
  "enum.SearchCategories.disbursement": "Uitbetaling",
  "enum.SearchCategories.divorceSeparation": "",
  "enum.SearchCategories.download": "Downloaden",
  "enum.SearchCategories.employment": "Dienstverband",
  "enum.SearchCategories.externalPayload": "Externe payload",
  "enum.SearchCategories.favourites": "Favorieten",
  "enum.SearchCategories.health": "Gezondheid",
  "enum.SearchCategories.incomingPayment": "Inkomende betalingen",
  "enum.SearchCategories.investmentFundHandling": "Beleggingsfondsafhandeling",
  "enum.SearchCategories.invoiceHandling": "Factuurafhandeling",
  "enum.SearchCategories.marriageCohabitantChildren": "",
  "enum.SearchCategories.migration": "Migratie",
  "enum.SearchCategories.new": "Nieuw",
  "enum.SearchCategories.outgoingPayment": "Uitgaande betalingen",
  "enum.SearchCategories.person": "Persoon",
  "enum.SearchCategories.policy": "Polis",
  "enum.SearchCategories.portfolio": "Portfolio",
  "enum.SearchCategories.portfolioHandling": "Portfolioafhandeling",
  "enum.SearchCategories.pretend": "Simuleren",
  "enum.SearchCategories.retirement": "",
  "enum.SearchCategories.specialCommands": "",
  "enum.SearchCategories.stop": "Stop",
  "enum.SearchCategories.tax": "Belasting",
  "enum.SearchCategories.tenant": "Fonds",
  "enum.SearchCategories.termination": "",
  "enum.SearchCategories.transfers": "Overdrachten",
  "enum.SearchGroup.command": "Commando",
  "enum.SearchGroup.navigation": "Navigatie",
  "enum.SearchGroup.recent": "Recent",
  "enum.SearchGroup.settings": "Instellingen",
  "enum.SearchGroup.tenant": "Fonds",
  "enum.ShortEmployerAgreementStatus.active": "A",
  "enum.ShortEmployerAgreementStatus.future": "T",
  "enum.ShortEmployerAgreementStatus.terminated": "B",
  "enum.Step.AddAccessGroupAnnotationStep": "Voeg toegangsgroepannotatie toe",
  "enum.Step.AddBalancePostingsStep": "Handmatig aangepast kapitaal",
  "enum.Step.AddFundMergeStep": "Fonds samenvoeging",
  "enum.Step.AddInsuredStep": "Deelnemer info toegevoegd",
  "enum.Step.AddMigrationStepV1": "Migratie",
  "enum.Step.AddMigrationStepV3": "Migratie",
  "enum.Step.AddMigrationStepV4": "Migratie",
  "enum.Step.AddPayableStopStep": "Betalingsstop toevoegen",
  "enum.Step.AddPaymentChannelStep": "Betalingskanaal toevoegen",
  "enum.Step.AddRelatedPersonStep": "Gerelateerde persoon toegevoegd",
  "enum.Step.AddUpaFileStep": "UPA Bestanden",
  "enum.Step.AddressChangeStep": "Wijzig adres",
  "enum.Step.AdvanceMonthStep": "Volgende maand",
  "enum.Step.AmendAccessGroupAnnotationStep": "Wijzig toegangsgroepannotatie",
  "enum.Step.AmendCoversSelectionStep": "Dekking gewijzigd",
  "enum.Step.AmendEmployerAgreementCoversStep": "Dekkingen werkgeversovereenkomst wijzigen",
  "enum.Step.AmendEmployerAgreementPoliciesStep": "Amend employer agreement policies",
  "enum.Step.BirthDateChangeStep": "Geboortedatum wijzigen",
  "enum.Step.ChangeAgreementStep": "Overeenkomst wijzigen",
  "enum.Step.ChangeCommitmentAndStateStep": "Handmatig aangepast",
  "enum.Step.ChangeCommitmentTemplateSourceStep": "Commitment sjabloon bron wijzigen",
  "enum.Step.ChangeContributionDataStep": "Change contribution data",
  "enum.Step.ChangeDataChannelStep": "Wijzig datakanaal",
  "enum.Step.ChangeNameStep": "Naam wijzigen",
  "enum.Step.ChangePartnerIdStep": "Partner-ID wijzigen",
  "enum.Step.ChangeRiskProfileStep": "Risicoprofiel wijzigen",
  "enum.Step.ChangeTemplateSourceStep": "Sjabloon bron wijzigen",
  "enum.Step.CloseCommitmentStep": "Deelname beëindigd",
  "enum.Step.CloseSubPortfolio": "Sluiten sub portfolio",
  "enum.Step.CloseSubPortfolioTrade": "Sluiten sub portfolio handel",
  "enum.Step.CreateAgreementStep": "Overeenkomst aanmaken",
  "enum.Step.CreateCompanyStep": "Bedrijf aanmaken",
  "enum.Step.CreateEmployment": "Nieuw dienstverband toegevoegd",
  "enum.Step.CreateInvoiceStep": "Factuur aanmaken",
  "enum.Step.CreatePaymentReceiverStep": "Betalingsontvanger aanmaken",
  "enum.Step.CreatePersonMigrationV3Step": "Nieuwe persoon gemigreerd",
  "enum.Step.CreatePersonStep": "Persoon aanmaken",
  "enum.Step.DeletePayableStopStep": "Betalingsstop verwijderen",
  "enum.Step.DeletePaymentChannelStep": "Betalingskanaal verwijderen",
  "enum.Step.DisablePenaltiesInvoiceStep": "Annuleer aanmaningskosten",
  "enum.Step.EditPayableStopStep": "Betalingsstop bewerken",
  "enum.Step.EditPaymentChannelStep": "Betalingskanaal bewerken",
  "enum.Step.EndPartnerMigrationV3Step": "Einde partner migratie",
  "enum.Step.EndPartnerMigrationV4Step": "Einde migratie partner",
  "enum.Step.EndPartnershipStep": "Einde partnerschap",
  "enum.Step.ExternalIdChangeStep": "Wijzig externe ID",
  "enum.Step.GenderChangeStep": "Wijzig geslacht",
  "enum.Step.HandleAnnuityMoneyOutStep": "Maandelijkse annuïteit verwerkt",
  "enum.Step.HandleCoverEndStep": "Dekking beëindigd",
  "enum.Step.HandleDeathBeneficiaryStep": "Overlijdensaanspraak toegevoegd",
  "enum.Step.HandleLumpSumMoneyOut": "Excasso bedrag ineens afhandelen",
  "enum.Step.HandlePolicyPostponeStep": "Pensionering uitgesteld",
  "enum.Step.HandleTemplateChangeStep": "Sjabloon wijziging afhandelen",
  "enum.Step.HandleTriggerMessageStep": "Extern bericht verwerkt",
  "enum.Step.HandleUnitlinkClosedPortfolioStep": "Gesloten portfolie UnitLink afhandelen",
  "enum.Step.HandleWopMoneyInStep": "Premievrijstelling verwerkt",
  "enum.Step.HandleYearStartStep": "Jaarovergang verwerkt",
  "enum.Step.InsuredPersonDeathUpdateBalanceStep": "Overlijdens update balans",
  "enum.Step.InsuredPersonStateParentStep": "Aanverwante persoon status ouder",
  "enum.Step.InternalCoverTransferStep": "Interne dekkingsoverdracht",
  "enum.Step.InternalTransferStep": "Interne overdracht verwerkt",
  "enum.Step.InvestmentSpec": "Investering specificatie",
  "enum.Step.InvestmentTrade": "Beleggingshandel",
  "enum.Step.MoveSubPortfolio": "Sub-portfolio verplaatsen",
  "enum.Step.NameChangeStep": "Wijzig naam",
  "enum.Step.NewSubPortfolios": "Nieuwe sub-portfolio aangemaakt",
  "enum.Step.NoChanges": "Ongewijzigd dienstverband",
  "enum.Step.NoUpdatesToInsuredStep": "Geen updates van verzekerde",
  "enum.Step.NoUpdatesToRelatedPersonStep": "Geen bijwerkingen voor aanverwante persoon",
  "enum.Step.PartnerBirthdateChangeStep": "Geboortedatum partner wijzigen",
  "enum.Step.PartnerDeceasedStep": "Overlijden partner",
  "enum.Step.PartnerNameChangeStep": "Naamswijziging partner",
  "enum.Step.PersonDeceasedStep": "Overlijden persoon",
  "enum.Step.PortfolioCorrection": "Portfolio correctie",
  "enum.Step.PortfolioDividend": "Portfolio dividend",
  "enum.Step.PortfolioFundCost": "Fondskosten",
  "enum.Step.PortfolioFundMerge": "Portfolio fonds samenvoeging",
  "enum.Step.PortfolioKickback": "Portfolio kickback",
  "enum.Step.PretendDeathStep": "Doen alsof overleden",
  "enum.Step.Rebalance": "Rebalance",
  "enum.Step.ReconcileInvoiceStep": "Factuur afstemmen",
  "enum.Step.RelatedPersonDeathStep": "Overlijden aanverwante persoon",
  "enum.Step.RelatedPersonStateParentStep": "Aanverwante persoon status ouder",
  "enum.Step.RelocationStep": "Verhuizing",
  "enum.Step.RemoveAccessGroupAnnotationStep": "Verwijder toegangsgroepannotatie",
  "enum.Step.ResumeInvoiceStep": "Factuur hervatten",
  "enum.Step.RetirementStep": "Pensionering",
  "enum.Step.RollbackStep": "Herberekening",
  "enum.Step.SendBillingStep": "Facturering verzenden",
  "enum.Step.SendReminderStep": "Herinnering verzenden",
  "enum.Step.SetDefaultPaymentChannelStep": "Standaard betalingskanaal instellen",
  "enum.Step.SetPartnerStep": "Partner instellen",
  "enum.Step.SetPersonStateStep": "Persoonsstatus instellen",
  "enum.Step.SetPortfolioOwner": "Stel portfolio eigenaar in",
  "enum.Step.StartEmployerRegistrationStep": "Start employer registration",
  "enum.Step.StartPartnerMigrationV3Step": "Start partner migratie",
  "enum.Step.StartPartnerMigrationV4Step": "Migratie partner starten",
  "enum.Step.SwitchSubPortfolioGroupCommandStep": "Portfolio wisselen voor klantpolis",
  "enum.Step.SwitchTrade": "Wissel van handel",
  "enum.Step.TradeExecution": "Handelsuitvoering",
  "enum.Step.UlBalance": "Saldo UnitLink",
  "enum.Step.UnitlinkConversion": "Conversie UnitLink",
  "enum.Step.UpdateCommunicationPreferenceStep": "Wijzigen communicatievoorkeur",
  "enum.Step.UpdateEmployment": "Dienstverband gewijzigd",
  "enum.Step.UpdateEmploymentFromDate": "Dienstverband aanvangsdatum gewijzigd",
  "enum.Step.UpdateNameStepApply": "Naamswijziging bijwerken toepassen",
  "enum.Step.UpdatePartnershipStep": "Update partnerschap",
  "enum.Step.UpdatePointOfContactStep": "Contactpunten wijzigen",
  "enum.TradeCycleEvent.AcknowledgeTradeOrderEvent": "Handelsorder bevestigd",
  "enum.TradeCycleEvent.AggregatedTradeCycleEvent": "Geaggregeerde handelscyclus",
  "enum.TradeCycleEvent.ClosedTradeCycleEvent": "Handelscyclus gesloten",
  "enum.TradeCycleEvent.CompletedTradeCycleEvent": "Voltooide handelscyclus",
  "enum.TradeCycleEvent.InvestedTradeCycleEvent": "Handelscyclus geinvesteerd",
  "enum.TradeCycleEvent.ManualFixupTradeCycleEvent": "Handmatige opknapping",
  "enum.TradeCycleEvent.SentTradeOrderEvent": "Handels order verzonden",
  "enum.TradeCycleEvent.StartTradeCycleEvent": "Handelscyclus gestart",
  "enum.TradeCycleEvent.TradePricesReceivedEvent": "Handelsprijzen ontvangen",
  "enum.TradeCycleStatus.aggregated": "Geaggregeerd",
  "enum.TradeCycleStatus.closed": "Gesloten",
  "enum.TradeCycleStatus.completed": "Compleet",
  "enum.TradeCycleStatus.completelyAcknowledged": "Compleet erkend",
  "enum.TradeCycleStatus.completelySent": "Compleet verzonden",
  "enum.TradeCycleStatus.invested": "Geinvesteerd",
  "enum.TradeCycleStatus.partlyAcknowledged": "Deels erkend",
  "enum.TradeCycleStatus.partlySent": "Handelsorder verzonden",
  "enum.TradeCycleStatus.somePricesReceived": "Deels ontvangen",
  "enum.TradeCycleStatus.started": "Gestart",
  "enum.scenarioHistoryState.applied": "Toegepast",
  "enum.scenarioHistoryState.cancelled": "Geannuleerd",
  "enum.scenarioHistoryState.closed": "Gesloten",
  "enum.scenarioHistoryState.open": "Open",
  "enum.searchEntity.company": "bedrijf",
  "enum.searchEntity.invoice": "factuur",
  "enum.searchEntity.person": "persoon",
  "error.applyStop": "Toepassen stop commando's: Er kunnen opdrachten worden toegevoegd, maar er kan niets worden toegepast. Als je probeert in te halen wat je gemist hebt, krijg je een foutmelding.",
  "error.applyStopSimulationNotPossible": "Toepassen stop: Simulatie is niet mogelijk",
  "error.communicationStop": "Communicatie stop: De gebeurtenisengine gebruikt deze vlag niet, maar specifieke gebeurtenisbronnen en stappen kunnen een betekenis aan deze vlag toewijzen.",
  "error.errorApplyStop": "De uitgevoerde commando's zijn gestopt vanwege fouten: {reason}",
  "error.fullStop": "Fuldt stop: Er kunnen geen opdrachten worden toegevoegd en er kan niets worden toegepast.",
  "error.validation.message": "Validatieprobleem",
  "event.helpText.viewAdvancedEventView": "Open geavanceerde gebeurtenisweergave",
  "event.helpText.viewFilter": "Bekijk filter",
  "event.helpText.viewGraphEventList": "Schakel over naar grafiekweergave",
  "event.helpText.viewHistory": "Bekijk stop geschiedenis",
  "event.helpText.viewPostings": "Bekijk posteringer",
  "event.helpText.viewTableEventList": "Schakel over naar tabelweergave",
  "eventBalancePostingsTable.title": "Saldoboekingen",
  "eventList.columns.after": "Na",
  "eventList.columns.applyDate": "Toepassing",
  "eventList.columns.before": "Voor",
  "eventList.columns.expectedApplyDate": "Verwacht toepassingsdatum",
  "eventList.columns.step": "Stap",
  "eventList.columns.unappliedCommand": "Niet toegepaste command",
  "eventList.columns.unappliedCommand.noCommandType": "Geen commando type",
  "eventList.columns.valueDate": "Systeemdatum",
  "eventList.filter.autoCommands": "Auto command's",
  "eventList.filter.events": "Gebeurtenissen",
  "eventList.filter.scenarioCommands": "Scenario commando's",
  "eventList.filter.showRecalculation": "Herberekening tonen",
  "eventList.title": "Gebeurtenissen",
  "eventOpenPostPostingsTable.title": "Openstaande berichten",
  "eventSelectionPostings.title": "Boeking voor geselecteerde gebeurtenissen",
  "eventsModal.title": "Gebeurtenis",
  "exportGlPostingsOriginalForm.component": "Component",
  "exportGlPostingsOriginalForm.seqNos": "Volgnummers",
  "exportReconciliationReportForm.component": "Component",
  "exportReconciliationReportForm.noSpecIdsWarning": "Geen spec-ID's gevonden voor de geselecteerde component",
  "exportReconciliationReportForm.specId": "Spec-ID",
  "exportSimulationModal.action": "Exporteer collectieve berekening simulatie",
  "exportSimulationModal.title": "Exporteer simulatie",
  "externalIdChange.company.title": "Wijzig externe bedrijfs-ID",
  "externalIdChange.newExternalId": "Nieuwe externe ID",
  "externalIdChange.person.title": "Wijzig externe persoons-ID",
  "externalIdChange.pseudoExternalId": "Pseudo BSN",
  "externalPayload.batchId": "Batch-ID",
  "externalPayload.batchesTab": "Batches",
  "externalPayload.blobName": "Blobnaam",
  "externalPayload.count": "Externe payloads ({count})",
  "externalPayload.creationTime": "Aanmaaktijd",
  "externalPayload.events.batch": "Batch",
  "externalPayload.events.deleted": "Verwijderd",
  "externalPayload.events.details": "Details",
  "externalPayload.events.newLatestEventId": "Nieuwe laatste gebeurtenis-ID",
  "externalPayload.events.originalStatus": "Oorspronkelijke status",
  "externalPayload.events.processId": "Proces-ID",
  "externalPayload.events.reason": "Reden",
  "externalPayload.events.stamp": "Tijdstip",
  "externalPayload.events.type": "Gebeurtenis",
  "externalPayload.externalPayloadsTab": "Externe payloads",
  "externalPayload.externalReference": "Externe referentie",
  "externalPayload.integrationName": "Integratie",
  "externalPayload.key": "Payloadsleutel",
  "externalPayload.missingPayloadLookupData": "Tenant-ID en batch-ID zijn vereist om externe payloads te vinden.",
  "externalPayload.noPayloadForBatch": "Er is geen externe payload gevonden voor deze batch.",
  "externalPayload.registrationDate": "Registratiedatum",
  "externalPayload.registrationFromDate": "Registratie vanaf",
  "externalPayload.registrationToDate": "Registratie tot",
  "externalPayload.showEvents": "Gebeurtenissengeschiedenis tonen",
  "externalPayload.showExternalPayloads": "Externe payloads tonen",
  "externalPayload.status": "Status",
  "externalPayload.tenantId": "Tenant-ID",
  "externalPayload.type": "Payloadtype",
  "externalPayload.user": "Gebruiker",
  "form.missingFrame.warning": "Waarschuwing",
  "frontpage.personaSwitcher": "Persona selectie",
  "frontpage.recentLinks": "Laatst bezochte links",
  "frontpage.welcome": "Welkom",
  "frontpage.welcomeMessage": "Hallo {name}",
  "fund.actions.addDividend": "Dividend toevoegen",
  "fund.actions.addFundMerge": "Voeg investeringsfonds samen",
  "fund.actions.createFund": "Investeringsfonds creëren",
  "fund.actions.update": "Update investeringsfonds",
  "fund.dividends": "Dividenden",
  "fund.graph.view": "Weergave",
  "fund.graph.view.daily": "Dagelijks",
  "fund.graph.view.monthly": "Maandelijks",
  "fund.graph.view.yearly": "Jaarlijks",
  "fund.prices": "Prijzen",
  "fund.prognosisAssetFractions": "Prognose activa fracties",
  "fund.table.view": "Tabelweergave",
  "fundCommandSelectionTable.addFund": "Fonds toevoegen",
  "fundCommandSelectionTable.currentCashValueFraction": "Huidige contante waarde fractie",
  "fundCommandSelectionTable.currentFraction": "Huidige fractie",
  "fundCommandSelectionTable.fund": "Fond",
  "fundCommandSelectionTable.fundsTableTitle": "Fonds voor {profileType}",
  "fundCorrection.amount": "Bedrag",
  "fundCorrection.isinKey": "Fonds",
  "fundCorrection.partitionKey": "Profiel types",
  "fundCorrection.units": "Eenheden",
  "fundPage.commandsEmpty.informationMessage": "Geen fonds gevonden voor {ininKey} in fonds {tenantId}",
  "funds.fundDividend.amount": "Bedrag per eenheid",
  "funds.fundDividend.date": "Ingangsdatum",
  "funds.fundDividends.element": "Dividend",
  "funds.fundItem": "Fonds item",
  "funds.fundItem.assetManagerId": "Vermogensbeheerder-ID",
  "funds.fundItem.createdBy": "Aangemaakt door",
  "funds.fundItem.creationStamp": "Aanmaak tijdstempel",
  "funds.fundItem.fundDividends": "Dividenten fonds",
  "funds.fundItem.fundMerge.date": "Datum",
  "funds.fundItem.fundMerge.destinationIsinKey": "Bestemming ISIN",
  "funds.fundItem.fundRiskLevel": "Risico level fonds",
  "funds.fundItem.internalCost": "Interne kosten",
  "funds.fundItem.internalId": "Interne ID",
  "funds.fundItem.isinKey": "ISIN",
  "funds.fundItem.name": "Naam",
  "funds.fundItem.prognosisAssetFractions": "Prognose beleggingsfracties",
  "funds.fundItem.shortName": "Korte naam",
  "funds.fundItem.usageEnded": "Gebruik beëindigd",
  "funds.fundItems.title": "Fondsen",
  "funds.fundPrices.buyPrice": "Aankoopprijs",
  "funds.fundPrices.date": "Datum",
  "funds.fundPrices.sellPrice": "Verkoopprijs",
  "funds.fundPrices.valuePrice": "Prijs",
  "funds.prognosisAssetFraction.element": "Prognose beleggingsfractie",
  "funds.prognosisAssetFraction.fraction": "Factor",
  "funds.prognosisAssetFraction.prognosisAssetClass": "Prognose beleggingscategorie",
  "genderChange.button": "Wijzig geslacht",
  "genderChange.field.changeDate": "Wijzigingsdatum",
  "genderChange.field.gender": "Geslacht",
  "groupedPayment.monthlyAmount": "Maandelijks bedrag",
  "groupedPayment.periodEnd": "Periode einde",
  "groupedPayment.periodStart": "Periode start",
  "hasField.commitmentVersion": "toezegging versie",
  "hasField.nonNegativeInvoiceAmount": "niet negatief factuurbedrag",
  "idToLegalEntity.accessDenied": "Je hebt geen toegang om deze entiteit te bekijken.",
  "installmentCreation.dueDate": "Vervaldatum",
  "installmentCreation.numberOfInstallments": "Aantal termijnen",
  "installments.amount": "Bedrag",
  "installments.dueDate": "Vervaldatum",
  "installments.outstandingAmount": "Openstaand bedrag",
  "installments.title": "Termijnen",
  "internalIdInput.externalCompany": "KvK",
  "internalIdInput.externalPerson": "BSN",
  "internalIdInput.identifierType": "ID-type",
  "internalIdInput.internal": "Interne ID",
  "internalIdInput.pseudoExternalPerson": "Pseudo BSN",
  "investmentSpecModalButton.title": "Investering specificatie",
  "invoiceOperation.dueDate": "Vervaldatum",
  "invoiceOperation.internalDueDate": "Interne vervaldatum",
  "invoiceOperation.operationDate": "Transactie datum",
  "invoiceOperation.operationId": "Transactie-ID",
  "invoiceOperation.status": "Status",
  "invoiceOperation.status.executed": "Uitgevoerd",
  "invoiceOperation.status.future": "Toekomst",
  "invoiceOperation.terminateAction": "Beëindigen",
  "invoiceOperation.title": "Transacties",
  "invoicePaymentVersions.addedDate": "Toevoegingsdatum",
  "invoicePaymentVersions.amount": "Bedrag",
  "invoicePaymentVersions.itemName": "betalingen",
  "invoicePaymentVersions.paymentDate": "Betaaldatum",
  "invoicePaymentVersions.title": "Betalingen",
  "invoicePaymentVersions.writeOffCategory": "Afschrijving categorie",
  "invoicePaymentVersions.writeOffType": "Afschrijving type",
  "invoiceSpecification.button": "Specificatie",
  "invoiceSpecification.title": "Specificatie",
  "invoiceTable.amount": "Bedrag",
  "invoiceTable.fromDate": "Van datum",
  "invoiceTable.invoiceDate": "Factuurdatum",
  "invoiceTable.invoiceId": "Factuurnummer",
  "invoiceTable.invoiceStatus": "Factuurstatus",
  "invoiceTable.requestedDueDate": "Vervaldatum",
  "invoiceTable.toDate": "Tot datum",
  "invoiceVersion.billingMethodType": "Facturatie methode type",
  "invoiceVersion.dueDate": "Vervaldatum",
  "invoiceVersion.installment": "Termijn",
  "invoiceVersion.internalDueDate": "Interne vervaldatum",
  "invoiceVersion.invoice": "Factuur",
  "invoiceVersion.invoiceStatus": "Status",
  "invoiceVersion.invoiceStrategyId": "Strategie-ID",
  "invoiceVersion.netAmount": "Netto bedrag",
  "invoiceVersion.partiallyPaidAmount": "Betaald bedrag",
  "invoiceVersion.payerId": "Betaler-ID",
  "invoiceVersion.suspensionDate": "Datum opschorting",
  "invoiceVersion.suspensionReason": "Reden opschorting",
  "invoiceVersion.totalAmount": "Totaalbedrag",
  "invoicesPage.title": "Facturen",
  "layout.navigation.annotation": "Annotaties",
  "layout.navigation.collCalc": "Collectieve berekeningen",
  "layout.navigation.funds": "Fondsen",
  "layout.navigation.home": "Home",
  "layout.navigation.moneyInMatch": "Match",
  "layout.navigation.moneyInPayments": "Betalingen",
  "layout.navigation.search": "Zoeken",
  "layout.navigation.tradeCycles": "Beleggingscyclus",
  "legalentity.rollbackEventModalButton.title": "Herberekening van legal entity gebeurtenissen",
  "life.enum.CoverType.PLACEHOLDER": "Tijdelijke aanduiding",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToAccountSpecification": "Terugbetaling naar account specificatie",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToLegalEntitySpecification": "Terugbetaling naar rechtspersoon specificatie",
  "life.enum.ReturnPaymentSpecificationType.ReturnPaymentToSenderSpecification": "Terugbetaling naar afzender specificatie",
  "life.rollbackEventModalButton.title": "Herberekening van toezegging gebeurtenissen",
  "limitAlert.moreResults": "Er zijn meer resultaten beschikbaar. Pas filters aan of voeg meer filters toe.",
  "lookupForm.info.id": "Als er een externe ID wordt gebruikt voor de zoekopdracht, gebruik dan geen speciale tekens (-, /, _, enz.).",
  "lookupForm.input.externalOrInternalId": "Externe of interne ID",
  "lookupForm.input.internalId": "Interne ID",
  "lumpsumPayments.amount": "Bedrag",
  "lumpsumPayments.heading": "Bedrag ineens betalingen",
  "lumpsumPayments.key": "Id",
  "lumpsumPayments.name": "Productnaam",
  "lumpsumPayments.paymentDate": "Betaaldatum",
  "lumpsumPayments.type": "Type",
  "main.tenantNotFound": "Keuze fonds kan niet worden gevonden",
  "markUnrelatedModal.input.unrelatedPaymentType": "Niet gerelateerd betalings type",
  "markUnrelatedModal.title": "Markeer als niet gerelateerd",
  "memberInfo.married": "Gehuwd",
  "missingField.birthDate": "geboortedatum",
  "moneyIn.amount": "Bedrag",
  "moneyIn.billingAmount": "Veronderstelde premies",
  "moneyIn.details.modalTitle": "Incasso boekingen",
  "moneyIn.employer": "Werkgever",
  "moneyIn.match.action.assignOwner": "Wijs eigenaar toe",
  "moneyIn.match.action.creditPaymentInvoice": "Factuur credit betaling",
  "moneyIn.match.action.markUnrelated": "Markeer als niet gerelateerd",
  "moneyIn.match.action.match": "Overeenkomst",
  "moneyIn.match.action.returnPayment": "Terugbetaling",
  "moneyIn.match.amount": "Bedrag",
  "moneyIn.match.attachInvoicePayment.accountId": "Account-ID",
  "moneyIn.match.attachInvoicePayment.receiverId": "Ontvangen-ID",
  "moneyIn.match.attachInvoicePayment.returnTo": "Terug naar",
  "moneyIn.match.date": "Datum",
  "moneyIn.match.debt": "Debet",
  "moneyIn.match.debtType": "Debet type",
  "moneyIn.match.debtType.installmentPlan": "Afbetalingsplan",
  "moneyIn.match.debtType.invoice": "Factuur",
  "moneyIn.match.filter.amountFrom": "Min bedrag",
  "moneyIn.match.filter.amountTo": "Max bedrag",
  "moneyIn.match.filter.includeClosed": "Beide open en dicht",
  "moneyIn.match.filter.isSuspended": "Opgeschort",
  "moneyIn.match.filter.originalPayment": "Originele betaling",
  "moneyIn.match.filter.resultLimit": "Limiet resultaten",
  "moneyIn.match.filter.resultLimit.option.noLimit": "Geen limiet",
  "moneyIn.match.invoiceContainedInInstallmentPlan": "Factuur maakt deel uit van afbetalingsplan {installmentPlanInfo}. Als deze niet zichtbaar is, probeer dan de filters aan te passen.",
  "moneyIn.match.invoicesTab": "Facturen",
  "moneyIn.match.netAmount": "Netto bedrag",
  "moneyIn.match.outstandingAmount": "Openstaand bedrag",
  "moneyIn.match.payerId": "Betaler-ID",
  "moneyIn.match.paymentType": "Type",
  "moneyIn.match.reference": "Ref",
  "moneyIn.match.status": "Huidige status",
  "moneyIn.match.suspendedAt": "Geschorst op",
  "moneyIn.match.title": "Betalingen",
  "moneyIn.match.totalAmount": "Totaal bedrag",
  "moneyIn.payments.amount": "Bedrag",
  "moneyIn.payments.entryRef": "Boeking ref",
  "moneyIn.payments.filter.originalPayment": "Originele betaling",
  "moneyIn.payments.ownerId": "Eigenaar-ID",
  "moneyIn.payments.paymentDate": "Datum betaling",
  "moneyIn.payments.paymentStatus": "Status",
  "moneyIn.payments.paymentType": "Type",
  "moneyIn.payments.reconcileInfo": "Afstemmingsinfo",
  "moneyIn.payments.title": "Betalingen",
  "moneyIn.period": "Periode",
  "moneyIn.title": "Incasso",
  "moneyIn.type": "Soort",
  "moneyInBundlingStopForm.bundlingStop": "Aanmaak factuur stop",
  "moneyOut.amount": "Bedrag",
  "moneyOut.cover": "Dekking",
  "moneyOut.details.modalTitle": "Excasso boekingen",
  "moneyOut.enum.PaymentChannel.IbanPaymentChannel": "IBAN",
  "moneyOut.enum.PaymentChannel.SwiftPaymentChannel": "SWIFT",
  "moneyOut.period": "Periode",
  "moneyOut.receiver": "Ontvanger",
  "moneyOut.receiverPal": "Belastingdienst",
  "moneyOut.stop.description": "Beschrijving: ",
  "moneyOut.stop.paymentType": "Type: {paymentType}",
  "moneyOut.title": "Excasso",
  "moneyOut.type": "Soort",
  "moneyOutLatestHistory.title": "Excasso laaste 10 bestanden",
  "nameChangeButton.button": "Wijzig naam",
  "nameChangeButton.field.changeDate": "Datum",
  "nameChangeButton.firstName": "Voornaam",
  "nameChangeButton.lastName": "Achternaam",
  "navigation.collCalc": "Collectieve berekeningen",
  "navigation.datamart": "Datamart",
  "navigation.datamart2": "Datamart 2",
  "navigation.legalentity": "Rechtspersoon",
  "navigation.legalentitydatareplicator": "Legal Entity gegevensreplicator",
  "navigation.life": "Life",
  "navigation.lifedatareplicator": "Life gegevensreplicator",
  "navigation.moneyin": "Incasso",
  "navigation.moneyout": "Excasso",
  "navigation.unitlink": "UnitLink",
  "navigation.unitlinkdatareplicator": "UnitLink gegevensreplicator",
  "newCcdCalculation.title": "Nieuwe CCD-berekening",
  "noRecordsFound": "Geen records gevonden",
  "openPostPosting.column.amount": "Bedrag",
  "openPostPosting.column.dim1": "Betalende partij",
  "openPostPosting.column.paymentDate": "Betaaldatum",
  "openPostPosting.column.reconcileNote": "Invoeg referentie",
  "openPostPosting.column.valueDate": "Valutadatum",
  "openPostPostingDetails.employerId": "Werkgever-ID",
  "openPostPostingDetails.valueDate": "Valutadatum",
  "openPostPostingVersion.accountType": "Accounttype",
  "openPostPostingVersion.amount": "Bedrag",
  "openPostPostingVersion.fromDueDate": "Vanaf vervaldatum",
  "openPostPostingVersion.limitedResultsHint": "Er worden slechts {count} resultaten weergegeven.",
  "openPostPostingVersion.matchable": "Overeenkomende betaling",
  "openPostPostingVersion.postingType": "Type boeking",
  "openPostPostingVersion.title": "Open post-berichten",
  "openPostPostingVersion.toDueDate": "Tot vervaldatum",
  "openPostPostingVersion.unmatchedAmount": "Bedrag",
  "openPostPostingVersion.valueDate": "Valutadatum",
  "openPostPostingVersion.voucher": "Voucher",
  "openPostPostings.matchable": "Overeenkomende betaling",
  "openPostPostings.postingType": "Type boeking",
  "openPostPostings.unmatchedAmount": "Bedrag",
  "openPostPostings.valueDate": "Datum",
  "option.insufficientAccessRights": "Onvoldoende toegang",
  "pageNotFound.backToHomepage": "Terug naar de startpagina",
  "pageNotFound.text": "De pagina die u zoekt, kan niet gevonden worden",
  "pageNotFound.title": "Niet gevonden",
  "pages.commitment.tabs.policies": "Polissen",
  "pages.commitment.tabs.policyEmptyReason": "Toezegging is {status}",
  "pages.landing.description": "Selecteer een component om te start",
  "paidUpPeriod.end": "Einddatum",
  "paidUpPeriod.start": "Startdatum",
  "paidUpPeriod.title": "Premievrij",
  "participantSection.ssn": "BSN",
  "partitionCommandSelectionTable.addNewPartition": "Nieuwe fractie",
  "partitionCommandSelectionTable.currentCashValueFraction": "Huidige spaarfractie",
  "partitionCommandSelectionTable.currentFraction": "Huidige betalingsfractie",
  "partitionCommandSelectionTable.partitionsTableTitle": "Geaggregeerde partities",
  "partitionCommandSelectionTable.profileType": "Profiel type",
  "partnerCard.birthdate": "Geboortedatum",
  "partnerCard.deathDate": "Overlijdensdatum",
  "partnerCard.endDate": "Einde relatie",
  "partnerCard.partnerName": "Naam",
  "partnerCard.startDate": "Aanvang relatie",
  "partnership.endDate": "Einde relatie",
  "partnership.partnerBirthdate": "Geboortedatum partner",
  "partnership.partnerDeathDate": "Partner overlijdensdatum",
  "partnership.partnerGender": "Partner geslacht",
  "partnership.partnerName.firstName": "Voornaam",
  "partnership.partnerName.initials": "Initialen",
  "partnership.partnerName.lastName": "Achternaam",
  "partnership.partnerPersonId": "Partner-ID",
  "partnership.partnershipId": "Partnerschap-ID",
  "partnership.partnershipType": "Soort partnerschap",
  "partnership.startDate": "Aanvang relatie",
  "partnershipHistoryModal.alert.noPreviousPartners": "Geen vorige partners om weer te geven",
  "partnershipHistoryModal.birthDate": "Geboortedatum",
  "partnershipHistoryModal.deathDate": "Overlijdensdatum",
  "partnershipHistoryModal.endDate": "Einde relatie",
  "partnershipHistoryModal.partnershipType": "Type verbintenis",
  "partnershipHistoryModal.personId": "BSN",
  "partnershipHistoryModal.startDate": "Aanvang relatie",
  "partnershipHistoryModal.title": "Relatie historie",
  "pauseInvoice.field.reason": "Reden",
  "pauseInvoice.field.transitionTo": "Overgang naar",
  "payableStops.moneyOut.history.action": "Historie",
  "payableStops.moneyOut.history.endDate": "Einddatum",
  "payableStops.moneyOut.history.startDate": "Begindatum",
  "payableStops.moneyOut.history.title": "Historie van uitbetalingsstops",
  "payableStops.moneyOut.modalTitle": "Betaling stopt",
  "payableStops.moneyOut.paymentType": "Type betaling",
  "payableStops.moneyOut.stopReason": "Reden stoppen",
  "payableStops.moneyOut.table": "Betaling stopt",
  "paymentChannel.accountNumber": "Rekeningnummer",
  "paymentChannel.accountType": "Rekening",
  "paymentChannel.bankAccount": "Rekeninggegevens",
  "paymentChannel.bic": "BIC",
  "paymentChannel.criteria": "Criteria",
  "paymentChannel.currency": "Valuta",
  "paymentChannel.default": "Standaard",
  "paymentChannel.ibanNumber": "IBAN",
  "paymentChannelCriterion.lifeInsuranceEvent": "Levensverzekeringsgebeurtenis",
  "paymentChannelCriterion.outgoingPaymentType": "Type betaling",
  "paymentChannels.history.action": "Historie",
  "paymentChannels.history.endDate": "Einddatum",
  "paymentChannels.history.startDate": "Begindatum",
  "paymentChannels.history.title": "Historie van betalingskanalen",
  "paymentChannels.title": "Betalingskanalen",
  "paymentInfoDetails.amount": "Bedrag",
  "paymentInfoDetails.entryRef": "Boeking ref",
  "paymentInfoDetails.ownerId": "Persoon-ID",
  "paymentInfoDetails.paymentDate": "Daum betaling",
  "paymentInfoDetails.reconcileInfo": "Afstemningsinformatie",
  "paymentInfoDetails.splitFromPaymentId": "Gesplitst van betaling",
  "paymentInfoDetails.status": "Status",
  "paymentInfoDetails.title": "Betaling",
  "paymentInfoDetails.type": "Type",
  "paymentSimulation.detailedView": "Gedetailleerd overzicht",
  "paymentSimulation.groupedMonthlyAndSinglePaymentsView": "Maandelijkse perioden en eenmalige betalingen",
  "paymentSimulation.title": "Excasso",
  "paymentSimulation.warning": "Er zijn niet-ondersteunde betalingstypen gevonden. Gebruik de gedetailleerde weergave: {missingFields}",
  "paymentsIn.graph.title": "Betalingen voor de laatste {year} jaren",
  "paymentsIn.notFound": "Geen betalingsinformatie gevonden voor deze deelnemer.",
  "paymentsIn.table.title": "Incasso",
  "paymentsIn.timeline.all": "Alles",
  "paymentsIn.timeline.filtered": "Gefilterd",
  "paymentsOut.graph.title": "Betalingen voor de laatste {year} jaren",
  "paymentsOut.notFound": "Geen betalingsinformatie gevonden voor deze deelnemer.",
  "paymentsOut.table.title": "Excasso",
  "paymentsOut.timeline.all": "Alles",
  "paymentsOut.timeline.filtered": "Gefilterd",
  "personEntityCard.birthdate": "Geboortedatum",
  "personEntityCard.deathDate": "Overlijdensdatum",
  "personEntityCard.initials": "Initialen",
  "personEntityCard.nationality": "Nationaliteit",
  "personEntityPage.workflowActions": "Workflow-acties",
  "personSection.stops": "Stops",
  "personStateDataDetails.birthDate": "Geboortedatum",
  "personStateDataDetails.deathDate": "Overlijdensdatum",
  "personStateDataDetails.personId": "Persoon-ID",
  "pointOfContact.button": "Contactpunten",
  "pointOfContact.enum.type.Email": "E-mail",
  "pointOfContact.enum.type.EmailVersion": "E-mail",
  "pointOfContact.enum.type.Fax": "Fax",
  "pointOfContact.enum.type.FaxVersion": "Fax",
  "pointOfContact.enum.type.Phone": "Telefoon",
  "pointOfContact.enum.type.PhoneVersion": "Telefoon",
  "pointOfContact.field.changeDate": "Wijzigingsdatum",
  "pointOfContact.field.email": "E-mail",
  "pointOfContact.field.fax": "Fax",
  "pointOfContact.field.isValid": "Is geldig",
  "pointOfContact.field.phone": "Telefoonnummer",
  "pointOfContact.field.pointOfContact": "Contactpunten",
  "pointOfContact.field.pointOfContacts": "Contactpunten",
  "pointOfContact.field.type": "Soort",
  "pointOfContact.field.value": "Contactgegevens",
  "pointOfContact.title": "Contactinformatie",
  "policiesSection.title": "Polissen",
  "policyInfoCard.fromDate": "Startdatum",
  "policyInfoCard.originalStartDate": "Originele startdatum",
  "policyInfoCard.status": "Status",
  "policyInfoCard.title": "Regeling info",
  "policyInfoCard.yearlyPensionableSalary": "Pensioengevend jaarsalaris",
  "policyTabs.aiSummary.title": "AI Samenvatting",
  "policyTabs.policiesTab": "Polis details",
  "policyTabs.totalTab": "Totaal",
  "portfolio.actualFraction": "Actuele fractie",
  "portfolio.advanced.view": "Geavanceerde weergave",
  "portfolio.allTrades": "All trades",
  "portfolio.amount": "Bedrag",
  "portfolio.cash.fundName": "Fonds naam",
  "portfolio.cash.isinKey": "ISIN sleutels",
  "portfolio.cashValue": "Kaswaarde",
  "portfolio.fund": "Fonds",
  "portfolio.fundCostBalance": "Saldo fondskosten",
  "portfolio.fundName": "Fondsnaam",
  "portfolio.history.view": "Historische weergave",
  "portfolio.investmentDetails": "Investering details",
  "portfolio.isinKey": "ISIN",
  "portfolio.notFound": "Geen portfolio gevonden voor deze deelnemer.",
  "portfolio.profileTypes": "Profiel types",
  "portfolio.real": "Werkelijk",
  "portfolio.realWithoutYield": "Werkelijk zonder opbrengst",
  "portfolio.simple.view": "Eenvoudige weergave",
  "portfolio.statement.detailedView": "Gedetailleerd overzicht",
  "portfolio.table.actual": "Actueel",
  "portfolio.table.aggregatedData": "Geaggregeerde",
  "portfolio.table.amounts": "Bedrag",
  "portfolio.table.expected": "Verwacht",
  "portfolio.table.fraction": "Fractie",
  "portfolio.table.fundCashValuePrice": "Portfolio waarde",
  "portfolio.table.invested": "Geïnvesteerd",
  "portfolio.table.subPortfolioGroupKey": "Polis",
  "portfolio.table.subPortfolioKey": "Dekkingen",
  "portfolio.table.sumOfUnits": "Aantal eenheden",
  "portfolio.table.total": "Totaal",
  "portfolio.table.unitPrice": "Eenheidsprijs",
  "portfolio.table.units": "Eenheden",
  "portfolio.table.wanted": "Gewenst",
  "portfolio.targetFraction": "Doelfractie",
  "portfolio.trade.orders": "Handels orders",
  "portfolio.tradeAmount": "Bedrag",
  "portfolio.tradeCostBalance": "Saldo handelskosten",
  "portfolio.tradeCycleType": "Type",
  "portfolio.tradeDate": "Datum",
  "portfolio.tradesOverview": "Handelsoverzicht",
  "portfolio.uninvested": "Investeringen",
  "portfolio.unitPrice": "Eenheidsprijs",
  "portfolio.units": "Eenheden",
  "portfolio.view.areaChart": "Oppervlaktediagram",
  "portfolio.view.days": "Dagen",
  "portfolio.view.lineChart": "Lijndiagram",
  "portfolio.view.months": "Maanden",
  "portfolio.view.years": "Jaren",
  "portfolio.yield": "Rendement",
  "portfolio.yieldForCurrentYear": "Rendement voor huidig jaar",
  "portfolioCorrection.subPortfolioCorrection": "Kies dekking",
  "portfolioCorrection.subPortfolioCorrections": "Dekkingsniveau",
  "portfolioCorrectionModalButton.title": "Portfolio correctie",
  "portfolioPage.commandsEmpty.informationMessage": "Geen portfolio gevonden voor {ownerId} in fonds {tenantId}",
  "portfolioTable.aggregated": "Geaggregeerde weergave van polissen",
  "postingEventCard.balanceDate": "Balance datum",
  "postingEventCard.postingAmount": "Boeking bedrag",
  "postingEventCard.postingSequenceNo": "Boeking volgorde nr.",
  "postingEventCard.postingValueDate": "Boeking valutadatum",
  "postings.column.accountType": "Accounttype",
  "postings.column.amount": "Bedrag",
  "postings.column.companyId": "Bedrijf-ID",
  "postings.column.coverKey": "Dekkingskenmerk",
  "postings.column.employerAgreementId": "Werkgeversovereenkomst-ID",
  "postings.column.fromAndToDueDate": "Periode",
  "postings.column.matchable": "Overeenkomende betaling",
  "postings.column.moneyOutReceiver": "Ontvanger",
  "postings.column.policyKey": "Polis kenmerk",
  "postings.column.postingType": "Type boeking",
  "postings.column.seqno": "Volgnr",
  "postings.column.tenantId": "Fonds",
  "postings.column.tenantSubGroup": "Regeling",
  "postings.column.transactionTime": "Transactie datum",
  "postings.column.truncated": "Incompleet",
  "postings.column.valueDate": "Valutadatum",
  "postings.column.voucher": "Voucher",
  "postings.column.workPadRef": "Werkblad",
  "postings.receiver": "Ontvanger",
  "postings.sender": "Afzender",
  "postings.title": "Boekingen",
  "postings.voucher.companyId": "Bedrijf-ID",
  "postings.voucher.creationStamp": "Aanmaak tijdstempel",
  "postings.voucher.employerAgreementId": "Werkgeversovereenkomst-ID",
  "postings.voucher.id": "Id",
  "postings.voucher.lifeInsuranceEvent": "Gebeurtenis",
  "postings.voucher.moneyOutReceiver": "Ontvanger betaling",
  "postings.voucher.policyKey": "Polis kenmerk",
  "postings.voucher.policyProductType": "Polis product type",
  "postings.voucher.stamp": "Tijdstempel",
  "postings.voucher.title": "Voucher voor verzending",
  "postings.voucher.traceId": "Traceer-ID",
  "postings.voucher.type": "Soort",
  "postings.voucher.userId": "Gebruiker-ID",
  "premiumHolidaysPeriod.end": "Einde dienstverband",
  "premiumHolidaysPeriod.start": "Aanvang dienstverband",
  "premiumHolidaysPeriod.title": "Premievakantie",
  "pretendDeathModalButton.deathDate": "Overlijdensdatum",
  "pretendDeathModalButton.title": "Overlijden simulatie",
  "prognosis.deflated": "Gebruik werkelijke uitkering",
  "recurringPayments.endDate": "Einddatum",
  "recurringPayments.heading": "Maandelijkse betalingen",
  "recurringPayments.key": "Id",
  "recurringPayments.monthlyAmount": "Betaling",
  "recurringPayments.name": "Productnaam",
  "recurringPayments.personName": "Ontvanger",
  "recurringPayments.productType": "Type",
  "recurringPayments.startDate": "Startdatum",
  "relatedCommitment.name": "Naam",
  "relatedCommitment.ssn": "BSN",
  "relatedCommitment.title": "Gerelateerde toezeggingen",
  "relatedInvoices.invoiceId": "Factuur-ID",
  "relatedInvoices.originalAmount": "Oorspronkelijk bedrag",
  "relatedInvoices.outstandingAmount": "Openstaand bedrag",
  "relatedInvoices.priority": "Prioriteit",
  "relatedInvoices.title": "Gerelateerde facturen",
  "relationshipInfo.noPartner": "Geen partner",
  "relationshipInfo.partnerStatus": "Huwelijksstatus",
  "remove": "Verwijderen",
  "reset": "Opnieuw instellen",
  "resumeInvoice.field.lastOperationDate": "Laatste transactie, datum",
  "resumeInvoice.field.lastOperationId": "Laatste transactie-ID",
  "resumeInvoice.field.newDueDate": "Nieuwe vervaldatum",
  "resumeInvoice.field.nextOperationDate": "Volgende operatie, datum",
  "resumeInvoice.field.nextOperationId": "Volgende operatie-ID",
  "retirementDate.expectedRetirementDate": "Verwachte pensioendatum",
  "retirementDate.retirementDate": "Pensioendatum",
  "retirementPeriod.end": "Einddatum",
  "retirementPeriod.start": "Startdatum",
  "returnPayment.title": "Terugbetaling",
  "riskBenefitSpecVersion.moneyOuttype": "Excasso type",
  "riskBenefitSpecVersion.noBenefit": "Geen uitkering",
  "riskCoverDetails.billingAccountBalance": "Nota account balans",
  "riskCoverDetails.billingAccountId": "Nota-account-ID",
  "riskCoverDetails.claimAccountBalance": "Claim account balans",
  "riskCoverDetails.claimAccountId": "Claimaccount-ID",
  "riskCoverDetails.coInsured": "Medeverzekerde",
  "riskCoverDetails.coInsuredBirthDate": "Geboortedatum medeverzekerde",
  "riskCoverDetails.coInsuredDeathDate": "Overlijdensdatum medeverzekerde",
  "riskCoverDetails.coverLayerDetails": "Dekkingsdetails",
  "riskCoverDetails.lifeInsuranceEvent": "Levensverzekeringgebeurtenis",
  "riskCoverDetails.relationshipId": "Relatie-ID",
  "riskCoverDetails.requiredRelationshipTypeForPayout": "Verplichte relatie type voor uitbetaling",
  "riskCoverDetails.riskBenefitSpecVersion": "Specificatie risico uitkering",
  "riskCoverDetails.riskEndDate": "Einddatum",
  "riskCoverDetails.title": "Risicodekking",
  "riskCoverSimulation.title": "Risicodekkingen",
  "rollbackForm.reason": "Reden",
  "rollbackForm.rollbackTo": "Herberekening to",
  "rowAction.download": "Download",
  "rowAction.view": "Details",
  "rowItem.enum.State.changed": "Gewijzigd",
  "rowItem.enum.State.deleted": "Verwijderd",
  "rowItem.enum.State.new": "Nieuw",
  "savingsContributionSpecDetails.closedforContribution": "Gesloten voor bijdrage",
  "savingsContributionSpecDetails.contributionSpecFraction": "Fractie",
  "savingsContributionSpecDetails.contributionSpecPriority": "Prioriteit",
  "savingsCoverDetails.expectedMoneyOutStartDate": "Verwachte startdatum excasso",
  "savingsCoverDetails.relationshipId": "Relatie-ID",
  "savingsCoverDetails.savingsAccount": "Kapitaalrekening",
  "savingsCoverDetails.savingsAccountBalance": "Saldo kapitaalrekening",
  "savingsCoverDetails.savingsContributionSpecVersion": "Bijdrage specificatie",
  "savingsCoverDetails.savingsTaxCode": "Belastingcode kapitaal",
  "savingsCoverDetails.title": "Kapitaaldekking",
  "savingsCoverSimulation.title": "Kapitaaldekkingen",
  "scenarioEventsList.noEvents": "Geen gebeurtenissen, voeg een gebeurtenis toe via de gebeurtenissen palet",
  "scenarioHistory.applied": "Toegepast",
  "scenarioHistory.appliedBy": "Toegepast door",
  "scenarioHistory.cancelled": "Geannuleerd",
  "scenarioHistory.cancelledBy": "Geannuleerd door",
  "scenarioHistory.created": "Aangemaakt",
  "scenarioHistory.createdBy": "Aangemaakt door",
  "scenarioHistory.eventList.eventTitle": "Variant",
  "scenarioHistory.eventList.showInformation": "Toon wie heeft aangemaakt, toegepast of geannuleerd",
  "scenarioHistory.eventList.state": "Status",
  "scenarioHistory.eventList.title": "Scenariovarianten",
  "scenarioHistory.filter.label": "Varianten filteren",
  "scenarioHistory.filter.onlyActionedByMe": "Alleen door mij toegepast of geannuleerd",
  "scenarioHistory.noCommands": "Deze variant heeft geen commando's.",
  "scenarioHistory.notRecordedYet": "Nog niet geregistreerd",
  "scenarioHistory.selectVariant": "Kies een variant in de lijst om de details en commando's te zien.",
  "scenarioHistory.title": "Scenariogeschiedenis",
  "scenarioHistory.untitledScenario": "Scenario zonder titel",
  "scenarioHistory.untitledVariant": "Variant zonder titel",
  "scenarioOverview.noCommands": "Geen commando's",
  "scenarioOverview.noScenariosExplainer": 'Maak een nieuw scenario door een commando uit te voeren in het commandopalet, waar je op "{scenarioButton}" klikt in plaats van "{applyButton}".',
  "scenarioOverview.noScenariosMatchSearch": "Geen scenario's gevonden voor je zoekopdracht.",
  "scenarioOverview.noVariantsAvailable": "Geen varianten beschikbaar.",
  "scenarioOverview.scenarioCountLabel": "{count} scenario's bestaan",
  "scenarioOverview.searchPlaceholder": "Zoek scenario's en varianten",
  "scenarioOverview.selectedLabel": "{scenarioTitle}, {variantTitle}",
  "scenarios.actions.apply": "Toepassen",
  "scenarios.actions.copyVariant": "Kopiëren",
  "scenarios.actions.deleteScenario": "Scenario verwijderen",
  "scenarios.actions.deleteVariant": "Variant verwijderen",
  "scenarios.actions.editScenario": "Scenario bewerken",
  "scenarios.actions.editVariant": "Variant bewerken",
  "scenarios.current": "Huidige",
  "scenarios.current.diffingDisabled.noCommitment": "Diffing is uitgeschakeld omdat de deelnemer geen toezeggingen.",
  "scenarios.current.selectForCompare": "Vergelijk met huidige",
  "scenarios.leave": "Verlaat scenario",
  "scenarios.simulationDate": "Simulatie datum",
  "scenarios.title": "Scenario",
  "search.categories.pages.agreement": "Overeenkomsten",
  "search.categories.pages.changes": "Veranderingen",
  "search.categories.pages.company": "Bedrijf",
  "search.categories.pages.health": "Gezondheid",
  "search.categories.pages.incomingPayment": "Inkomende betalingen",
  "search.categories.pages.outgoingPayment": "Uitgaande betalingen",
  "search.categories.pages.person": "Persoon",
  "search.categories.pages.policy": "Polis",
  "search.categories.pages.portfolio": "Portfolio",
  "search.categories.pages.tax": "Belasting",
  "search.categories.recent.lastWeek": "Vorige week",
  "search.categories.recent.older": "Ouder",
  "search.categories.recent.today": "Vandaag",
  "search.categories.recent.yesterday": "Gisteren",
  "search.entityNoInformation": "Er kan geen informatie worden weergegeven voor deze {entity}. Dit kan zijn omdat deze nog niet in het systeem bestaat. Of omdat de entiteit gestopt is.",
  "search.lookupExternalId": "Zoek {id}",
  "searchEntity.address": "Adres",
  "searchEntity.agreements": "Overeenkomsten",
  "searchEntity.amount": "Bedrag",
  "searchEntity.birthDate": "Geboortedatum",
  "searchEntity.deathDate": "Overlijdensdatum",
  "searchEntity.externalId": "Externe-ID",
  "searchEntity.gender": "Geslacht",
  "searchEntity.internalId": "Interne ID",
  "searchEntity.lookup.allAccessDenied": "Je hebt geen toegang om een van de resultaten te bekijken.",
  "searchEntity.lookup.notFound": "Geen resultaten gevonden.",
  "searchEntity.lookup.partialAccessDenied": "Je hebt geen toegang om alle resultaten te bekijken.",
  "searchEntity.navigate": "Navigeren",
  "searchEntity.payer": "Betaler",
  "searchForm.search": "Zoeken",
  "searchInput.birthDate": "Geboortedatum",
  "searchInput.email": "E-mail",
  "searchInput.firstName": "Voornaam",
  "searchInput.lastName": "Achternaam",
  "searchInput.phoneNumber": "Telefoonnummer",
  "searchNotFound.message": "Er zijn geen resultaten gevonden",
  "searchResultsCard.column.address": "Adres",
  "searchResultsCard.column.birthDate": "Geboortedatum",
  "searchResultsCard.column.emails": "E-mails",
  "searchResultsCard.column.name": "Naam",
  "searchResultsCard.column.phoneNumbers": "Telefoonnummers",
  "searchResultsCard.title": "Zoekresultaten",
  "setCommitmentTime.dateTime": "Datum en tijd",
  "setCommitmentTime.doNotCatchUp": "Niet bijwerken",
  "setCommitmentTime.form.warning": "Door de datum handmatig in te stellen, kan deze toezegging de tijd van de systeemcomponent niet meer volgen!",
  "setCommitmentTime.title": "Wijzig toezeggingstijd",
  "showInstallments.amount": "Bedrag",
  "showInstallments.dueDate": "Vervaldatum",
  "simulation.showDiffing": "Verschillen tonen",
  "skipAutoHandlingCommitmentSourceExternalPayloadModalButton.title": "Automatische verwerking van externe payload van de toezeggingsbron overslaan",
  "specifications.column.action.moveToExternalHandling": "Verplaats naar externe handeling",
  "specifications.column.amount": "Bedrag",
  "specifications.column.reference": "Referentie",
  "specifications.column.uniqueNtryRef": "Boeking ref",
  "specifications.column.valueDate": "Betaald",
  "status.stopped": "Gestopt",
  "stopAlert.invoiceCreation": "Factuuraanmaak",
  "stopEvents.applicationVersion": "Applicatie versie",
  "stopEvents.applyStop": "Toepassen stop commando's",
  "stopEvents.changedBy": "Gewijzigd door",
  "stopEvents.communicationStop": "Communicatie stop",
  "stopEvents.configurationVersionNumber": "Configuratie versie nummer",
  "stopEvents.creationStamp": "Aanmaaktijd",
  "stopEvents.date": "Datum",
  "stopEvents.errorApplyStop": "De uitgevoerde commando's zijn gestopt vanwege fouten",
  "stopEvents.fullStop": "Volledige stop",
  "stopEvents.reason": "Reden",
  "stopEvents.stackTraceDetails": "Technische details (stack trace)",
  "stopEvents.title": "Stop geschiedenis",
  "subPortfolioCorrection.amount": "Bedrag",
  "subPortfolioCorrection.coverKey": "Dekking",
  "subPortfolioCorrection.fundCorrection": "Kies fonds",
  "subPortfolioCorrection.fundCorrections": "Fondsniveau",
  "subPortfolioCorrection.policyKey": "Polis",
  "subPortfolioEmployment.helpText": "Polisweergave zoals getoond aan de klant",
  "subPortfolioKeyInputs.resetSubPortfolioKeys": "Reset dekkingen",
  "subPortfolioKeyInputs.subPortfolioGroupKey": "Polis",
  "subPortfolioKeyInputs.subPortfolioKey": "Dekking",
  "switchSubPortfolioForm.subPortfolioKeys": "Dekkingen",
  "switchSubPortfolioForm.switchCommandType": "Type wisselcommando",
  "switchSubPortfolioGroupForm.resetSubPortfolioKeys": "Subportfoliosleutels resetten",
  "switchSubPortfolioGroupForm.subPortfolioGroupKeys": "Klantpolissen om te wisselen",
  "switchSubPortfolioGroupForm.switchCommandType": "Type wisselopdracht",
  "switchSubPortfolioGroupModalButton.title": "Portfolio wisselen voor klantpolis",
  "switchSubPortfolioModalButton.title": "Switch portfolio for covers",
  "switchTradeModalButton.fundSelection": "Fonds keuze",
  "switchTradeModalButton.fundSelection.isinKey": "ISIN sleutel",
  "switchTradeModalButton.fundSelection.percentage": "Percentage",
  "switchTradeModalButton.fundSelections": "Fonds keuzes",
  "switchTradeModalButton.profileType": "Profiel type",
  "switchTradeModalButton.rebalance": "Rebalance",
  "switchTradeModalButton.title": "Handel wijzigen",
  "switchTradeModalButton.updateProfile": "Profiel bijwerken",
  "timeModal.addDay": "+1 dag",
  "timeModal.addMonth": "+1 maand",
  "timeModal.addYear": "+1 jaar",
  "timeModal.setTime": "Zet tijd",
  "timeModal.title": "Systeem tijd",
  "timeline.commandLane.applyDate": "Toepassingsdatum",
  "tradeCycle.buyPrice": "Aankoopprijs",
  "tradeCycle.cycle.amount": "Bedrag",
  "tradeCycle.cycle.assetManagerId": "Vermogensbeheerder-ID",
  "tradeCycle.cycle.events": "Gebeurtenissen",
  "tradeCycle.cycle.isinKey": "ISIN sleutels",
  "tradeCycle.cycle.title": "Handelscyclus",
  "tradeCycle.cycle.type": "Type",
  "tradeCycle.cycle.units": "Eenheden",
  "tradeCycle.fundName": "Fund Naam",
  "tradeCycle.isinkey": "ISIN",
  "tradeCycle.sellPrice": "Verkoopprijs",
  "tradeCycle.tradeOrderStatus.acknowledged": "Bevestigd",
  "tradeCycle.tradeOrderStatus.allPricesReceived": "Alle prijzen ontvangen",
  "tradeCycle.tradeOrderStatus.assetManagerId": "Vermogensbeheerder-ID",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.notReceived": "{isin} (niet ontvangen)",
  "tradeCycle.tradeOrderStatus.fundPriceStatus.received": "{isin} (ontvangen)",
  "tradeCycle.tradeOrderStatus.fundPriceStatuses": "Fonds prijzen statussen",
  "tradeCycle.tradeOrderStatus.orderId": "Bestelling-ID",
  "tradeCycle.tradeOrderStatus.sent": "Verzonden",
  "tradeCycle.tradePrices": "Handelsprijzen",
  "tradeCycleOverview.fromTime": "Vanaf",
  "tradeCycleOverview.status": "Status",
  "tradeCycleOverview.title": "Handelscyclus overzicht",
  "tradeCycleOverview.tradeCycleType": "Type",
  "type.enum.Address.AbroadAddress": "Buitenland",
  "type.enum.Address.Address": "Adres",
  "type.enum.Address.InformalAddress": "Informeel",
  "unitlinkCoverVoucher.amount": "Bedrag",
  "unitlinkCoverVoucher.coverKey": "Dekkingskenmerk",
  "unitlinkCoverVoucher.policyKey": "Polis kenmerk",
  "unitlinkCoverVoucher.profileType": "Profil soort",
  "update": "Bijwerken",
  "updateBalance.calculationDate": "Berekeningsdatum",
  "updateBalance.description": "Dit zal het UnitLink-saldo voor de portfolio berekenen en bijwerken.",
  "updateBalance.title": "Saldo bijwerken voor alle polissen",
  "updateCommitmentSourceExternalPayloadModalButton.postingId": "Boeking",
  "updateCommitmentSourceExternalPayloadModalButton.title": "Werk de externe payload van de bron van de toezegging bij",
  "updateCommunicationPreference.field.changeDate": "Wijzigingsdatum",
  "updateCommunicationPreference.field.communicationPreferenceType": "Communicatievoorkeur",
  "updateCommunicationPreference.title": "Communicatievoorkeur",
  "updateCompanyName.button": "Bedrijfsnaam",
  "updateCompanyName.name": "Naam",
  "updatePartnerButton.buttonAdd": "Toevoegen partner",
  "updatePartnerButton.buttonUpdate": "Wijzig partner",
  "updatePartnerButton.changeDate": "Wijzigingsdatum",
  "uploadHistoricalInputsModal.action": "Importeer historische input",
  "userSettings.enum.theme.dark": "Donker",
  "userSettings.enum.theme.light": "Licht",
  "userSettings.enum.theme.system": "Systeem",
  "userSettings.user": "Gebruiker",
  "validation.companyId": "KvK is niet geldig",
  "validation.enabled": "Formulier valideren",
  "validation.ssn": "BSN is niet geldig",
  "validationMessage.overrideButtonText": "Overschrijven",
  "validationMessage.overrideMessage": "Bericht overschrijven",
  "validationOverridesInEffect.key": "Overschrijvingssleutel",
  "validationOverridesInEffect.reason": "Reden",
  "validationOverridesInEffect.title": "Validatie overschrijvingen in effect",
  "viewPaymentModal.invoiceId": "Factuur-ID",
  "viewPaymentModal.paymentType.ReturnedPayment": "Terugbetaalde betaling",
  "viewPaymentModal.paymentType.invoicePayment": "Factuurbetaling",
  "viewPaymentModal.paymentType.settledPayment": "Settled payment",
  "viewPaymentModal.paymentType.splitPayment": "Gesplitste betaling",
  "viewPaymentModal.paymentUsage": "Bruik",
  "viewPaymentModal.paymentUsageType": "Gebruikstype",
  "viewPaymentModal.settledWithPaymentId": "Betaald met betalings-ID",
  "viewPaymentModal.splitToPaymentIds": "Gesplitst naar betalings-ID's",
  "viewPaymentModal.userId": "Gebruikers-ID",
  "workPad.creationStamp": "Gemaakt",
  "workPad.title": "Werkblad",
  "workPad.userId": "Gemaakt door",
})
